import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import {
  TextField, Button, Typography, Paper, Grid, Dialog, DialogContent, IconButton, Icon, CircularProgress, withWidth, Switch,
} from '@material-ui/core';
import AsyncSelect from 'react-select/async'
import * as FieldValidation from './CreateAndEditResource/FieldValidation';
import * as GenerateStateForEditing from './CreateAndEditResource/GenerateStateForEditing';
import SearchableSelect from '../share/SearchableSelect';
import InvalidVariationDialog from '../share/InvalidVariationDialog';
import ModeEditIcon from '@material-ui/icons/ModeEdit';
import { TimePicker, DateTimePicker } from 'material-ui-pickers';
import { resourceFormStyle, commonResourceStyle, nestedAddressStyle } from '../../css/style';
import customizationLogo from '../../assets/img/customization_logo.svg';
import {
  isEqual, isEmpty, cloneDeep, pick, isString, last, sortBy, every, get, set, forEach,
} from 'lodash';
// import * as Sentry from '@sentry/browser';
import moment from 'moment';
import flowRight from 'lodash/flowRight';
import {
  resourceFields,
  productIcons,
  days,
  currencyCodes,
  reportFrequency,
  orderTypes,
  valueKeys,
  couponActionTypes,
  restricitionTypes,
  daysOfWeek,
  deliveryType,
  defaultCustomizationFields,
  tiersRewardType,
  payAtDoorOptions,
  restrictionTypeIndex,
  restrictionValueIndex,
  squareIdIndex,
  outOfStockBooleanVersion,
  squareIdLettersAndNumbersOnly,
  instructions,
  validationErrorMessages,
  fieldIndexes,
  hoursIndex,
  deliveryTimeIndex,
  pickupTimeIndex,
  deliveryServices,
  searchableItemsResources,
  rewardTypes,
  timeLimitsIndex,
  fieldsWithSelectAllOption,
  resourceDisplayNameMap,
  MAX_CHAR_DESCRIBE_TEXTFIELD,
  MAX_CHAR_DESCRIPTION_RESOURCES,
} from '../../data/Constants';
import * as OutOfStockAPIFormat from '../../api/outOfStock/OutOfStockAPIFormat';
import * as utilFunctions from '../../utils/Functions';
import * as IdentifyPage from '../../utils/IdentifyPage';
import DisplayImages from '../share/DisplayImages';
import Hours from '../share/Hours';
import HolidayHours from '../share/HolidayHours';
import Dropdown from '../share/Dropdown';
import CraverRadio from '../share/CraverRadio';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import CollapsibleItem from '../share/CollapsibleItem';
import DeleteConfirmDialog from '../share/DeleteConfirmDialog';
import EditorDialog from '../share/EditorDialog';
import TimeLimit from '../share/TimeLimit';
import ProductIcon from '../share/ProductIcon';
import ItemCustomization from '../share/ItemCustomization';
import ToolTip from '../share/ToolTip';
import AdvancedProductDialog from '../share/AdvancedProductDialog';
import Variation from '../share/Variation';
import VersionInfo from '../../config/version.json';
import VersionAndBuildNumber from '../share/VersionAndBuildNumber';
import { checkIsAuthorized, getLocationIdOfAuthorizationOrAdmin, checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import * as FormSubmits from '../../utils/FormSubmits';
import * as TimeLimitUtils from '../../utils/TimeLimitUtils';
import { getSearchableEntities, getUsers } from '../../domains/Restrictions';
import * as MultiAccountAdminRedirects from '../../services/MultiAccountAdminRedirects';
import * as HoursUtils from '../../utils/HoursUtils';
import { withStyles } from '@material-ui/core/styles';
import Immutable from 'seamless-immutable';
import debounce from 'debounce-promise';

const reselectDateTimeText = utilFunctions.translation('reselectDateTime');

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
const nestedAddressStyles = nestedAddressStyle();
const IosSwitch = withStyles(styles.iosSwitchStyles)(Switch);
const searchableRestrictionTypes = [
  'CATEGORY',
  'PRODUCT',
  'PRODUCT_ITEM',
  'EXCLUDE_CATEGORY',
  'EXCLUDE_PRODUCT',
  'EXCLUDE_PRODUCT_ITEM',
  'LOCATIONS',
  'USERS',
];
class CreateAndEditResource extends Component {
  constructor(props) {
    super(props);
    const { type } = this.props;
    this.state = type === 'create' ? this.createStateForCreating() : this.createState();
    const loadOptions = inputValue => this.loadUsers(inputValue);
    this.debouncedLoadOptions = debounce(loadOptions, 500);
  }

  componentDidMount = async () => {
    const {
      apiToken, match, actions, loading, resources, type,
    } = this.props;
    const {
      resource, subResource, subResourceId, resourceId,
    } = match.params;

    const resourceListFromReduxStore = resources[resource];
    const resourceList = resourceListFromReduxStore || await actions.getAllResources(apiToken, resource);
    const unwrappedResourceList = get(resourceList, 'response', resourceList);

    if (!resources.users && resource === 'users') {
      actions.getAllResources(apiToken, 'users', resourceId, 'addresses');
    }

    const resourceType = subResource || resource;
    const resourceToLoad = resourceFields[resourceType].filter(field => field.loadSeperately);

    if (loading === false && resource === 'products' && (type === 'create' || type === 'edit')) {
      actions.getAllResources(apiToken, 'taxes');
    }
    // Loads the full list of locations into Redux store for out of stock per location to work correctly, because if you start on CreateAndEditResource, then go to the Locations page, then
    // hit the browser Back button, the Locations page overwrites the full list with a subset of all locations.
    if (loading === false && resource === 'products') {
      actions.getAllResources(apiToken, 'locations');
      actions.getAllResources(apiToken, 'customizations');
    }
    if (loading === false && resource === 'products' && type === 'edit') {
      const productOutOfStockRes = await actions.getAllResources(apiToken, 'products', resourceId, 'out-of-stock');

      // Get out of stock per location status for all product items
      if (!Array.isArray(unwrappedResourceList)) return;
      const editingProduct = unwrappedResourceList.find(elem => (elem.id && `${elem.id}` === resourceId));
      if (!editingProduct || !Array.isArray(editingProduct.items)) return;

      const itemsIsFieldInvalidState = {};

      const itemOutOfStockRequestPaths = editingProduct.items.map((item) => {
        this.createNewIsFieldInvalidKeysForCollapsibleItem(itemsIsFieldInvalidState, item.id);
        return ['products', resourceId, 'items', item.id, 'out-of-stock'];
      });

      await actions.batchRequests('getAllResources', apiToken, itemOutOfStockRequestPaths);

      this.setState(itemsIsFieldInvalidState);
    }
    if (loading === false && resource === 'locations' && (type === 'create' || type === 'edit')) {
      const companiesRes = await actions.getAllResources(apiToken, 'companies');
    }
    if (loading === false && resource === 'companies' && type === 'edit') {
      await actions.getAllResources(apiToken, 'companies');
    }
    if (loading === false && resource === 'customizations' && subResource === 'options') {
      if (this.props.resources && this.props.resources.customizations && Array.isArray(this.props.resources.customizations)) {
        // Load locations fresh, as you might be coming from the Locations page with only a subset of locations in the Redux store
        await actions.getAllResources(apiToken, 'locations');
        await actions.getAllResources(apiToken, 'customizations', resourceId, 'options');
        if (type === 'edit') {
          const outOfStockRes = await actions.getAllResources(apiToken, 'customizations', resourceId, 'options', subResourceId, 'out-of-stock');
          const outOfStockValue = outOfStockRes.response;
          const outOfStockSelectedOptions = this.prepareNonConstantResourceFieldMultiSelectValue('outOfStock', outOfStockValue, 'name', 'id');
          this.setState({ outOfStock: outOfStockSelectedOptions });
        }
      }
    }
    if (loading === false && resource === 'coupons' && subResource === 'restrictions') {
      const databaseInitValue = this.state.value;
      const initType = this.state.type;
      let ids = [];
      const VALID_RESOURCE_TYPES = ['CATEGORY', 'PRODUCT', 'PRODUCT_ITEM', 'EXCLUDE_CATEGORY', 'EXCLUDE_PRODUCT', 'EXCLUDE_PRODUCT_ITEM', 'LOCATIONS'];
      if (VALID_RESOURCE_TYPES.includes(this.state.type)) {
        ids = databaseInitValue.split(',');
      }
      actions.getAllResources(apiToken, 'categories')
        .then((res) => {
          let searchableCategories = [];
          if (res.error || !res.response) {
            this.setState({ searchableCategories });
            return;
          }
          let value = [];
          res.response.forEach((category) => {
            if (!category.name || !category.id) return;
            const searchableCategory = { label: category.name, value: category.id };
            searchableCategories.push(searchableCategory);
          });

          searchableCategories = sortBy(searchableCategories, ['label', 'value']);

          if (['CATEGORY', 'EXCLUDE_CATEGORY'].includes(initType)) {
            value = searchableCategories.filter(category => ids.includes(`${category.value}`));
            this.setState({ searchableCategories, value });
            return;
          }
          this.setState({ searchableCategories });
        });
      actions.getAllResources(apiToken, 'products')
        .then((res) => {
          let value = [];
          let { searchableProducts, searchableProductItems } = utilFunctions.buildUpSearchableProductsAndItems(res);
          if (Array.isArray(res.response)) {
            if (['PRODUCT', 'EXCLUDE_PRODUCT'].includes(initType)) {
              value = searchableProducts.filter(product => ids.includes(`${product.value}`));
              this.setState({ searchableProducts, searchableProductItems, value });
              return;
            }
            if (['PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM'].includes(initType)) {
              value = searchableProductItems.filter(item => ids.includes(`${item.value}`));
              this.setState({ searchableProducts, searchableProductItems, value });
              return;
            }
            this.setState({ searchableProducts, searchableProductItems });
          }
        });
      actions.getAllResources(apiToken, 'locations')
        .then((res) => {
          const searchableLocations = getSearchableEntities(res);
          const value = ['LOCATIONS'].includes(initType)
            ? searchableLocations.filter(location => ids.includes(`${location.value}`))
            : null;

          this.setState({
            searchableLocations,
            ...(value && { value }),
          });
        });
      actions.getSearchedUsers(apiToken, `users?start=0&count=25`)
        .then((res) => {
          const searchableUsers = getUsers(res);
          this.setState({ searchableUsers });
      });
      if (!resources.coupons) {
        new Promise((resolve, reject) => {
          actions.getAllResources(apiToken, resource).then(
            actions.getAllResources(apiToken, resource, resourceId, subResource),
          );
          resolve();
        }).catch();
      } else {
        const restrictions = this.retrieveItems();
        if (!restrictions) actions.getAllResources(apiToken, resource, resourceId, subResource);
      }
    }
    if (loading === false && resource === 'tiers') {
      let ids = Array.isArray(this.state.productItems) ? this.state.productItems : [];
      actions.getAllResources(apiToken, 'products')
        .then((res) => {
          if (res.error) return;
          let { searchableProducts, searchableProductItems, itemNamesForIds } = utilFunctions.buildUpSearchableProductsAndItems(res, true);
          let productItems = searchableProductItems.filter(searchableItem => ids.includes(searchableItem.value));
          this.setState({
            searchableProducts, searchableProductItems, itemNamesForIds, productItems,
          });
        });
    }
    if (loading === false && resource === 'customizations' && !subResource && (resourceId || type === 'create')) {
      const productsPagination = get(this.props, 'pagination.products', {});
      const { start, count, totalSize } = productsPagination;
      if (!start || !count || !totalSize || start + count < totalSize) {
        actions.getAllResources(apiToken, 'products')
          .then((res) => {
            if (res.error) return;
            const { attachedItemIds, allItemCustomizationsAndProductIds } = utilFunctions.getItemsAttachedToCustomization(res, resourceId);
            const { searchableProductItems, itemNamesForIds } = utilFunctions.buildUpSearchableProductsAndItems(res, true);
            const productItems = searchableProductItems.filter(searchableItem => attachedItemIds.get(searchableItem.value));
            this.setState({
              searchableProductItems,
              itemNamesForIds,
              productItems,
              allItemCustomizationsAndProductIds,
              originalAttachedItems: attachedItemIds,
            });
          });
      }
    }
    if (resourceToLoad.length > 0) {
      resourceToLoad.map(async (resource) => {
        if (loading === false && !resources[resource.dataTable]) {
          // fetch customizations, locations, and productTax before dialog opens
          await actions.getAllResources(apiToken, resource.dataTable);
        }
      });
      if (type === 'edit') {
        const resourcePath = (subResource) ? [resource, resourceId, subResource, subResourceId] : [resource, resourceId];
        resourceToLoad.map(async (resource) => {
          await actions.getAllResources(apiToken, ...resourcePath, resource.key).then(async (res) => {
            if (resource.key === 'locations') {
              this.setState({ locations: res.response });
            }
          });
        });
      }
    }

    const { hours } = this.state;
    if (hours) this.updateInitialHoursThenValidate(hours);

    const { deliveryServices: deliveryService } = (resources.companies && Array.isArray(resources.companies) && resources.companies[0]) || {};
    if (deliveryService && deliveryServices.includes(deliveryService) && this.state.deliveryTime && this.state.pickupTime) {
      this.deliveryTimeValidation(deliveryService, this.state.deliveryTime.toString(), { key: 'deliveryTime' });
      this.deliveryTimeValidation(deliveryService, this.state.pickupTime.toString(), { key: 'pickupTime' });
    }
  }

  retrieveItems = () => {
    const { resourceId } = this.props.match.params;
    const { resources } = this.props;
    const currentCoupon = resources.coupons.find(coupon => coupon.id == resourceId);
    return currentCoupon ? currentCoupon.restrictions : [];
  };

  componentWillReceiveProps = (nextProps) => {
    const {
      resources, type, match,
    } = this.props;
    const { resource, subResource, resourceId } = match.params;
    const thisProduct = resources.products && resources.products.filter(product => Number(product.id) === Number(resourceId))[0];
    const nextProduct = nextProps.resources && nextProps.resources.products && nextProps.resources.products.filter(product => Number(product.id) === Number(resourceId))[0];
    if ((!isEqual(this.props, nextProps) && resource !== 'products' && type !== 'edit')
      || (isEmpty(resources) && resource === 'products' && type === 'edit')
      || (resources && resources.products && !isEqual(resources.products, nextProps.resources.products) && subResource === 'items' && type === 'edit')
    ) {
      const state = type === 'create' ? this.createStateForCreating() : this.createState(nextProps.resources);
      this.setState(state);
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    const {
      resources, match, history, type, apiToken, actions,
    } = this.props;
    const {
      resource, subResource, resourceId, subResourceId,
    } = match.params;
    const redirectArgs = {
      apiToken,
      actions,
      resource,
      history,
      locationStateParams: { fromCreateAndEditResource: true },
    };

    const { value } = this.state;
    let newUserIdsToNames = [];
    const restrictions = resources.coupons && this.retrieveItems();
    const userIds = value;
    if (restrictions && restrictions.length > 0 && prevState.userIdsToNames !== this.state.userIdsToNames) {
      const userIdsString = value.map(user => user.value).join();
      const userIdsArray = userIdsString.split(',');
      const otherUserRestrictions = restrictions.filter((restriction) => restriction.id != subResourceId && restriction.type === 'USERS');
      const allUserRestrictionsIds = otherUserRestrictions.map(restriction => restriction.value).join() + ',' + userIdsString;
      const allUserRestrictionsIdsArray = allUserRestrictionsIds.split(',');
      const allDuplicatedUsers = allUserRestrictionsIdsArray.filter((user, index) => allUserRestrictionsIdsArray.indexOf(user) != index);
      const duplicatedUsers = [...new Set(allDuplicatedUsers.filter(user => userIdsArray.includes(user)))];
      this.setState({ duplicatedUserIds: duplicatedUsers });
      if (duplicatedUsers[0]) {
        this.setState({ disableSaveButton: true })
      } else {
        this.setState({ disableSaveButton: false })
      }
    }
    if (restrictions && restrictions.length > 0 && !this.state.userIdsToNames) {
      let paginationStart = 0;
      let paginationEnd = 500000;
      do {
        userIds && actions.getSearchedUsers(apiToken, `users?start=${paginationStart}&count=${paginationEnd}&filter=id:${userIds}`)
          .then((res) => {
            const users = (getUsers(res));
            if (Array.isArray(users)) {
              users.forEach((user) => {
                if (!user || !user.value || !user.label) return;
                newUserIdsToNames = newUserIdsToNames.concat(user);
              });
                this.state.userIdsToNames = newUserIdsToNames;
            }
            return newUserIdsToNames;
          });
          paginationStart = paginationEnd;
          paginationEnd = paginationEnd + 500000;
      }
      while (userIds && this.state.userIdsToNames.length != userIds.split(',').length);
    }
    if (prevProps.apiToken !== apiToken) {
      if (resource === 'products' || resource === 'orders' || resource === 'users') {
        MultiAccountAdminRedirects.redirectToResourcePage(redirectArgs);
      } else if (resource === 'categories' || resource === 'customizations' || resource === 'tiers' || resource === 'coupons') {
        await MultiAccountAdminRedirects.redirectToResourcePageWithRefresh(redirectArgs);
      } else if (resource === 'locations') {
        MultiAccountAdminRedirects.redirectToResourcePage(redirectArgs);
      }
    }

    if (resource === 'customizations' && subResource === 'options' && type === 'edit') {
      const prevCustomizations = get(prevProps, 'resources.customizations');
      const customizations = get(this.props, 'resources.customizations');
      if (!prevCustomizations && customizations) {
        const newState = this.createState(this.props.resources);
        this.setState(newState);
        return;
      }
    }

    if (resource === 'products' && type === 'edit') {
      const locations = get(this.props, 'resources.locations');
      const singleLocation = Array.isArray(locations) && locations.length === 1;
      const isOutOfStock = Array.isArray(prevState.outOfStock) && typeof this.state.outOfStock === 'boolean'
      if (prevState.outOfStock != this.state.outOfStock && singleLocation && isOutOfStock) {
        this.setState({ outOfStock: prevState.outOfStock });
      }
    }

    const resourceType = (subResource) || (resource);
    const fields = resourceFields[resourceType];

    const pathname = this.props.location && this.props.location.pathname.toString();
    const prevPathname = prevProps.location && prevProps.location.pathname.toString();
    const currPathParams = pathname && pathname.length ? pathname.split('/') : []
    const prevPathParams = prevPathname && prevPathname.length ? prevPathname.split('/') : []
    const isUsers = currPathParams[1] === 'users'
    const isPrevEdit = prevPathParams[prevPathParams.length - 1] === 'edit'
    const isCreate = currPathParams[currPathParams.length - 1] === 'create'
    const isEdit = currPathParams[currPathParams.length - 1] === 'edit'

    if (isUsers && isPrevEdit && isCreate) {
      resourceFields.addresses.forEach((field) => {
        this.setState({ [field.key]: null });
      });
    } else if (isUsers && isEdit) {
      let user;
      let address;
      let addressFields = {};
      const isObjectEmpty = isEmpty(resources);
      if (!isObjectEmpty) {
        user = resources[resource].filter(user => user.id.toString() === resourceId.toString());
        user = user[0];
      }
      if (user &&
        (user.name !== this.state.name) &&
        (user.email !== this.state.email)) {
        this.setState({
          ...this.state,
          ...user,
        })
      }
      if (user.addresses && user.addresses.length) {
        address = user.addresses.filter(address => address.id.toString() === subResourceId.toString());
        address = address[0];
        for (let field in fields) {
          if (!(Object.keys(address).includes(fields[field].key))) {
            addressFields[fields[field].key] = '';
          } else {
            addressFields[fields[field].key] = address[fields[field].key];
          }
        }
        resourceFields.addresses.forEach((field) => {
          this.setState({ [field.key]: Object.values(pick(addressFields, field.key))[0] });
        });
      }
    } else if (history.location.state && history.location.state.product && (pathname === '/products/items/create' || pathname === '/products/create')) {
      if (!isEqual(prevProps, this.props)) {
        const { product, categories } = history.location.state;
        this.setState({ product, categories });

        if (product.icons && product.icons.length > 0) {
          let isIconChecked = [];
          productIcons.forEach((item, index) => {
            if (product.icons.includes(item.key)) {
              isIconChecked.splice(index, 0, true);
            } else {
              isIconChecked.splice(index, 0, false);
            }
          });

          this.setState({
            product: {
              ...product,
              productItems: product.productItems,
              iconSwitch: true,
              isIconChecked,
            },
          });
        }
      }
    } else if (resource === 'products' && !subResource && type === 'edit' && !isEqual(prevProps, this.props)) {
      let prevPropsProduct;
      if (prevProps && prevProps.resources && prevProps.resources.products) {
        prevPropsProduct = prevProps.resources.products.find(product => Number(product.id) === Number(resourceId));
      }
      const currProduct = resources.products && resources.products.find(product => Number(product.id) === Number(resourceId));

      if (prevPropsProduct && currProduct) {
        const { items: prevItems, ...prevOthers } = prevPropsProduct;
        const { items: currItems, ...currOthers } = currProduct;
        if (!isEqual(prevItems, currItems) && isEqual(prevOthers, currOthers)) {
          this.setState({ items: currItems });
          return;
        }
      }

      let justEditedProductOutOfStockInReduxStore = false;
      if (prevPropsProduct && !prevPropsProduct['out-of-stock'] && !prevPropsProduct['out-of-stock'] && currProduct && currProduct['out-of-stock']) {
        justEditedProductOutOfStockInReduxStore = true;
      }
      if (justEditedProductOutOfStockInReduxStore) {
        const productOutOfStockSelectedOptions = this.prepareNonConstantResourceFieldMultiSelectValue('outOfStock', currProduct['out-of-stock'], 'name', 'id');
        this.setState({ outOfStock: productOutOfStockSelectedOptions });
      }

      // Limit the changes this block makes to `this.state.product` and `this.state.items` to when an API fetch has new product/item information not about out-of-stock locations.
      // This block would otherwise run too often and revert the user's state out-of-stock values to the last API fetch stored in the Redux store.
      if (!justEditedProductOutOfStockInReduxStore && !isEqual(prevPropsProduct, currProduct)) {
        currProduct && this.setState({
          ...currProduct,
          items: currProduct.items,
        });
      }
      // When changing coupon restriction's variable field type, clear previous restriction value and its validation errors
    } else if (resource === 'coupons' && subResource === 'restrictions' && prevState.type !== this.state.type && this.state.type) {
      let value;
      // If these boolean restrictions are chosen at all, their value is true. Use the pop-up menu in DisplayResources to delete them.
      if (['FIRST_ORDER_OF_CUSTOMER', 'APPLY_TO_EACH_ITEM'].includes(this.state.type)) {
        value = true;
      } else {
        value = null;
      }
      this.setState({
        value,
        isFieldInvalid: Array(resourceFields.restrictions.length).fill(false),
        disableSaveButton: false,
      });
    }
    if (prevProps.match.url !== this.props.match.url) {
      let { isFieldInvalid } = this.state;
      isFieldInvalid.forEach((field, index) => {
        isFieldInvalid[index] = false;
      });
      this.setState({ isFieldInvalid });
    }
    // After adding a new item with the Edit Product -> Add Item button, add new isFieldInvalid state for the new item
    if (resource === 'products' && !subResource && Array.isArray(prevState.items) && Array.isArray(this.state.items) && this.state.items.length > prevState.items.length) {
      const lastItem = this.state.items[this.state.items.length - 1];
      const newStateFields = {};
      this.createNewIsFieldInvalidKeysForCollapsibleItem(newStateFields, lastItem.id);
      this.setState(newStateFields);
    }
  }

  createNewIsFieldInvalidKeysForCollapsibleItem = (objectToMergeIntoState, itemId) => {
    const isFieldInvalid = {};
    const invalidFieldMessage = {};
    resourceFields.items.forEach((field) => {
      isFieldInvalid[field.key] = null;
      invalidFieldMessage[field.key] = null;
    });
    objectToMergeIntoState[`item${itemId}IsExpanded`] = false;
    objectToMergeIntoState[`item${itemId}IsFieldInvalid`] = isFieldInvalid;
    objectToMergeIntoState[`item${itemId}InvalidFieldMessage`] = invalidFieldMessage;
  }

  createDropdownOptionsStateFromString = (fieldKey, resourceField, allowMultiple) => {
    const {
      resource, resourceId, subResource, subResourceId,
    } = this.props.match.params;
    if (!resource || !resourceId) return [];
    let selectedOptionsString = '';
    let correctResource = this.props.resources[resource].find(val => val.id === parseInt(resourceId, 10));
    if (!subResource || !subResourceId) {
      selectedOptionsString = correctResource[fieldKey];
      return this.rehydrateDropdownOptions(selectedOptionsString, resourceField, allowMultiple);
    }
    if (subResource && subResourceId) {
      const correctSubResource = correctResource[subResource].find(val => val.id == parseInt(subResourceId, 10));
      selectedOptionsString = correctSubResource[fieldKey];
      return this.rehydrateDropdownOptions(selectedOptionsString, resourceField, allowMultiple);
    }
  }

  rehydrateDropdownOptions = (selectedOptionsString, resourceField, allowMultiple) => {
    const splitted = selectedOptionsString.split(',');
    const correctOptions = resourceField.filter(elem => splitted.includes(elem.value));
    if (allowMultiple) return correctOptions;
    // Single dropdowns expect an object, correctOptions is an array of objects
    return correctOptions[0];
  }

  /**
   * state for editing resource
   */
  createState = (newResources, currSingleResource, nextSingleResource) => {
    const { resources, match } = this.props;
    const {
      resource, resourceId, subResource, subResourceId,
    } = match.params;
    const resourceType = (subResource) || (resource);
    const fields = resourceFields[resourceType];
    const dialogState = {
      openEditDialog: false,
      editDialogField: null,
      newContent: '',
    };
    let state = {};
    const findEntityArgs = { resources, match, newResources };
    const itemToEdit = (subResource) ? utilFunctions.findSubEntityByID(findEntityArgs) : utilFunctions.findEntityByID(findEntityArgs);
    state.id = subResourceId || resourceId;
    state.dialogState = dialogState;
    state.isFieldInvalid = new Array(fields.length);
    state.invalidFieldMessage = new Array(fields.length);
    state.disableSaveButton = false;
    state.errorText = '';
    fields.map((field) => {
      if (resource === 'customizations' && field.key === 'position') {
        state.startingPosition = get(itemToEdit, 'position');
      }
      // For the payAtDoorOptions dropdown to work, we need to turn the string received from the database into an array of objects.
      const isCreatingPayAtDoorOptions = field.key === 'payAtDoorOptions' && itemToEdit && itemToEdit.payAtDoorOptions && isString(itemToEdit.payAtDoorOptions);
      const isCreatingCouponRestrictionValueState = resource === 'coupons' && subResource === 'restrictions' && field.key === 'value';
      if (isCreatingPayAtDoorOptions) {
        const payAtDoorOptionsRehydrated = this.createDropdownOptionsStateFromString('payAtDoorOptions', payAtDoorOptions, true);
        return state.payAtDoorOptions = payAtDoorOptionsRehydrated;
      }
      if (isCreatingCouponRestrictionValueState && state.type === 'DAYS_OF_WEEK') {
        return state.value = this.createDropdownOptionsStateFromString('value', daysOfWeek, true);
      }
      if (isCreatingCouponRestrictionValueState && state.type === 'DELIVERY_TYPE') {
        return state.value = this.createDropdownOptionsStateFromString('value', deliveryType, true);
      }
      if (isCreatingCouponRestrictionValueState && ['START_TIME_OF_DAY', 'END_TIME_OF_DAY'].includes(state.type)) {
        return state.value = this.createTimeStateFromStringForTimePicker(['HH:mm', 'h:mma', 'hh:mma'], 'value');
      }
      // Keep outOfStock the value it previously was in this.state, as this `createState` method is called after every API request made in componentDidMount,
      // such as to retrieve product locations. `createState` resets the outOfStock value.
      if (field.key === 'outOfStock' && resource === 'products' && !subResource && this.state
        && (typeof this.state.outOfStock === 'boolean'
          || (this.state.outOfStock && Array.isArray(this.state.outOfStock))
        )
      ) {
        return this.state.outOfStock;
      }
      // For older Edit Item route /products/:id/items/:item_id/edit, return the isDefault already in the form's state if API requests do not change it
      if (field.key === 'isDefault' && resource === 'products' && resourceId && subResource === 'items' && subResourceId) {
        const hasApiIsDefaultChangedForAnyItem = this.compareItemsIsDefaultValue(currSingleResource, nextSingleResource);
        if (!hasApiIsDefaultChangedForAnyItem) return;
      }

      if (field.key === 'items' && resource === 'products') {
        const items = get(itemToEdit, 'items', undefined);
        const itemsClone = cloneDeep(items);
        return state.items = itemsClone;
      }

      // TO-DO: CRV-9751 Clone other nested objects from the Redux store.
      // Sometimes the Admin panel sends the original nested object even though it seems edited when you inspect this.state.
      return state[field.key] = itemToEdit && itemToEdit[field.key];
    });

    state.timeLimitSwitch = false;
    state.daysOfWeekButtons = [];
    state.deletedTimeLimits = [];
    state.areTimeLimitSubfieldsValid = [];

    state.iconSwitch = false;
    state.isIconChecked = new Array(productIcons.length);

    state.stockSwitch = false;

    state.disabledSwitch = false;

    state.showNoteSwitch = false;

    state.isItemCusDialogOpen = false;
    state.itemCusDialogContent = state.customizations;

    state.isDeleteConfirmDialogOpen = false;
    state.dataInDeleteConfirmDialog = '';

    const {
      timeLimits, icons, outOfStock, isDisabled, showNote,
    } = state;
    if (icons && icons.length > 0) {
      state.iconSwitch = true;
      productIcons.map((item, index) => {
        if (icons.includes(item.key)) {
          state.isIconChecked[index] = true;
        }
      });
    }

    if (outOfStock) {
      state.stockSwitch = true;
    }

    if (isDisabled) {
      state.disabledSwitch = true;
    }

    if (showNote) {
      state.showNoteSwitch = true;
    }

    if (timeLimits && timeLimits.length > 0 && timeLimits[0].daysOfWeek.length > 0) {
      state = GenerateStateForEditing.initializeTimeLimits(state);
    } else {
      state.daysOfWeekButtons = [new Array(7)];
      state.timeLimits = [{ daysOfWeek: [], end: null, start: null }];
    }
    state.userIdsToNames = null;
    state.duplicatedUserIds = null;
    return state;
  };


  compareItemsIsDefaultValue = (currProduct, nextProduct) => {
    // If there's no product yet in state, you want to let the API results change the Redux store
    if (!currProduct || !nextProduct) return true;
    const { items } = currProduct;
    const nextItems = nextProduct.items;
    let hasApiIsDefaultChangedForAnyItem = false;
    const itemsIdToIsDefaultMap = {};
    items.forEach((item) => {
      itemsIdToIsDefaultMap[`a${item.id}`] = item.isDefault;
    });
    nextItems.forEach((item) => {
      if (item.isDefault === itemsIdToIsDefaultMap[`a${item.id}`]) return;
      hasIsDefaultChangedForAnyItem = true;
    });
    return hasApiIsDefaultChangedForAnyItem;
  }

  prepareNonConstantResourceFieldMultiSelectValue = (resourceName, resource, nameFieldName, valueFieldName) => {
    if (!resource || !resourceName || !nameFieldName || !valueFieldName) return [];
    if (resourceName === 'outOfStock') {
      return resource.map((elem, ind) => ({
        name: elem[nameFieldName],
        value: elem[valueFieldName],
        id: ind,
      }));
    }
    return [];
  }

  createTimeStateFromStringForTimePicker = (formatString, fieldKey) => {
    const {
      resource, resourceId, subResource, subResourceId,
    } = this.props.match.params;
    if (!resource || !resourceId) return moment();
    let timeString = '';
    let correctResource = this.props.resources[resource].find(val => val.id === parseInt(resourceId, 10));
    if (!subResource || !subResourceId) {
      timeString = correctResource[fieldKey];
      return moment(timeString, formatString, true);
    }
    if (subResource && subResourceId) {
      const correctSubResource = correctResource[subResource].find(val => val.id == parseInt(subResourceId, 10));
      timeString = correctSubResource[fieldKey];
      return moment(timeString, formatString, true);
    }
  }

  /**
   * state for creating resource
   */
  createStateForCreating = (subresourceName) => {
    const { match } = this.props;
    const {
      resource, subResource, subResourceId, resourceId,
    } = match.params;

    const resourceType = subresourceName || ((subResource === 'view' ? 'customizations' : subResource) || resource);
    const fields = resourceFields[resourceType];

    const state = {};
    const dialogState = {
      openEditDialog: false,
      editDialogField: null,
      newContent: '',
    };

    state.dialogState = dialogState;
    state.disableSaveButton = false;
    state.isFieldInvalid = new Array(fields.length);
    state.invalidFieldMessage = new Array(fields.length);
    state.errorText = '';

    state.timeLimitSwitch = false;
    state.daysOfWeekButtons = [new Array(7)];
    state.deletedTimeLimits = [];
    state.areTimeLimitSubfieldsValid = [];

    state.isAdvancedDialogOpen = false;

    state.isItemCusDialogOpen = false;

    fields.map((field) => {
      if (field.key === 'position' && resource === 'customizations') state.startingPosition = 0;
      // empty hours is allowed when creating a new location
      if (['hours', 'orderTypes', 'outOfStock'].includes(field.key)) {
        state[field.key] = [];
      } else {
        state[field.key] = null;
      }
    });

    state.product = {
      component: 'PRODUCT',
      customizationView: 'STEP_VIEW',
      widthPercentage: 50,
      iconSwitch: false,
      isIconChecked: new Array(productIcons.length),
      isDisabled: false,
      disabledSwitch: false,
      showNote: false,
      showNoteSwitch: false,
      productItems: [
        {
          id: 0,
          name: 'Regular',
          attribute_name: 'Size',
          attribute_value: 'Regular',
          price: 0,
          isDefault: true,
          isDisabled: false,
          disabledSwitch: false,
          itemCusDialogContent: [],
        },
      ],
    };

    state.timeLimits = [{ daysOfWeek: [], end: null, start: null }];

    return state;
  }

  /**
   * sets the state according to the TYPE and KEY of the field
   */
  onChangeInput = (event, field, isSubResource, id, variationIndex) => {
    const dropdownOptions = this.getDropdownOptions(field, isSubResource, id);
    const { match } = this.props;
    const {
      resources, resource, subResource,
    } = match.params;
    const fieldName = (subResource === 'view' ? 'customizations' : subResource) || (resource);
    const pathname = this.props.location && this.props.location.pathname.toString();
    let inputVal;

    // When editing coupon restrictions, the `value` field has a variable type. We need to handle it
    // differently from the base case.
    let correctFieldType = '';
    let couponRestrictionTypeAsFieldKey = '';
    const isRenderingCouponRestrictionValueField = resource === 'coupons' && subResource === 'restrictions' && field.key === 'value';
    if (isRenderingCouponRestrictionValueField) {
      const stateType = this.state.type;
      // If no restrictionType is chosen, render the value field as a TextField from Constants.resourceFields.restrictions
      if (!stateType) {
        correctFieldType = field.type;
      }
      // If the user chose a restrictionType, instead take correctFieldType from Constants.restrictionTypes
      if (stateType) {
        correctFieldType = restricitionTypes.find(type => stateType === type.value).type;
        couponRestrictionTypeAsFieldKey = stateType;
      }
    } else {
      correctFieldType = field.type;
    }
    if (correctFieldType === 'dropdown') {
      const dropdownFields = ['locations', 'includedOptions', 'orderTypes', 'payAtDoorOptions', 'DAYS_OF_WEEK', 'outOfStock', 'out-of-stock', 'DELIVERY_TYPE'];
      if (dropdownFields.includes(field.key) || dropdownFields.includes(couponRestrictionTypeAsFieldKey)) {
        inputVal = utilFunctions.getSelectedOptions(event, dropdownOptions, true, field.key);
      } else {
        inputVal = utilFunctions.getSelectedOptions(event, dropdownOptions);
      }
    } else {
      inputVal = (event.target) ? event.target.value : event;
    }
    // Handles input change and verification for CollapsibleItems on /products/:id/edit
    if (isSubResource) {
      const subResourceData = this.state[isSubResource];
      const isDefaultChecked = field.key === 'isDefault' && inputVal === true;
      const newSubResource = subResourceData.map((item) => {
        if (isDefaultChecked && item.id !== id && item.isDefault === true) {
          item[field.key] = false;
        }
        if (item.id === id) {
          item[field.key] = inputVal;
          this.fieldVerificationForItems(inputVal, field, item, this.state[`item${item.id}IsExpanded`]);
        }
        return item;
      });
      return this.setState({ [isSubResource]: newSubResource });
    }
    if (field.key === 'tier' && !event) {
      this.setState({ [field.key]: null });
      return;
    }
    if (field.key === 'widthPercentage') {
      if (inputVal.value !== this.state.initialWidth) {
        this.setState({ isWidthChanged: true });
      } else {
        this.setState({ isWidthChanged: false });
      }
    }

    const isNumericField = ['decimal', 'number', 'nonZeroInt', 'allDecimalsAllowed'].includes(correctFieldType)
      || field.key === 'coordinates';
    if (isNumericField) this.fieldVerification(inputVal, field);
    if (field.key === 'hours') this.hoursValidation(inputVal, field);
    if (field.key === 'squareId') {
      const isSquareIdValid = this.validateSquareId(inputVal);
      const isFieldInvalidCopy = this.state.isFieldInvalid.slice();
      if (isSquareIdValid) {
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: squareIdIndex, isFieldInvalidCopy });
      } else {
        const invalidFieldMessageCopy = this.state.invalidFieldMessage.slice();
        const errorMessage = this.getErrorMessage(squareIdIndex, field, inputVal);
        const showErrorArgs = {
          fieldIndex: squareIdIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
        };
        this.showValidationErrorAndDisableSave(showErrorArgs);
      }
    }
    const { deliveryServices: deliveryService } = (Array.isArray(this.props.resources.companies) && this.props.resources.companies[0]) || {};
    if (deliveryService && deliveryServices.includes(deliveryService)) {
      this.deliveryTimeValidation(deliveryService, inputVal, field);
    }
    if (valueKeys.includes(field.key)) {
      this.setState({ [field.key]: inputVal && inputVal.value });
    } else if (field.key === 'orderTypes' && isEqual(inputVal, orderTypes)) {
      this.setState({ [field.key]: [] });
    } else if (field.key === 'orderTypes') {
      const result = inputVal.map(type => type.value);
      this.setState({ [field.key]: result });
    } else if (resource === 'products' && this.state.product && this.state.product.productItems && (pathname === '/products/items/create' || pathname === '/products/create')) {
      const { product } = this.state;
      const { productItems } = product;
      // Handles input change and verification for /products/items/create
      if (subResource === 'items') {
        productItems.forEach((item) => {
          if (field.key === 'attribute_value' && item.selectedItem === true) {
            item[field.key] = inputVal;
            item.name = this.makeItemNameFromProductAndAttributeValue(product, item);

            this.fieldVerificationForItems(inputVal, field, item);

            // Subtle: the `|| item.selectedItem === true` in the next line means this block handles most fields in Create Product Item Advanced Options
          } else if (field.key === 'attribute_name' || item.selectedItem === true) {
            item[field.key] = inputVal;
            this.fieldVerificationForItems(inputVal, field, item);
          }
        });

        this.setState({
          product: {
            ...product,
            productItems,
          },
        });
        // Handles input change and verification for /products/create
      } else if (field.key === 'name') {
        const items = productItems.map((item) => {
          if (item.attribute_value !== null) {
            item[field.key] = `${inputVal} ${item.attribute_value}`;
          } else {
            item[field.key] = inputVal;
          }
          return item;
        });
        this.setState({
          product: {
            ...product,
            [field.key]: inputVal,
            productItems: items,
          },
        });
        this.fieldVerification(inputVal, field);
      } else if (field.key === 'attribute_name') {
        productItems.forEach((item) => {
          item[field.key] = inputVal;
        });
        this.setState({
          product: {
            ...product,
            productItems,
          },
        });
      } else if (field.key === 'attribute_value') {
        productItems.forEach((item, index) => {
          if (index === variationIndex) {
            item[field.key] = inputVal;
            item.name = this.makeItemNameFromProductAndAttributeValue(product, item);
          }
        });
        this.setState({
          product: {
            ...product,
            productItems,
          },
        });
      } else if (field.key === 'isDefault' || field.key === 'price') {
        const items = productItems.map((item, index) => {
          if (index === variationIndex) {
            item[field.key] = inputVal;
          }
          return item;
        });
        this.setState({
          product: {
            ...product,
            productItems: items,
          },
        });
      } else if (field.key === 'outOfStock') {
        this.setState({ outOfStock: inputVal });
      } else {
        this.setState({
          product: {
            ...product,
            [field.key]: inputVal,
          },
        });
        this.fieldVerification(inputVal, field);
      }
    } else {
      this.setState({ [field.key]: inputVal }, () => this.checkIfNoDefaultItemOnInputChange(field));
      if (resource === 'products' && subResource === 'items') {
        // For the 1) Edit Item page /products/:id/items/:item_id/edit if you start from /products/:product_id/edit, then manually
        // type /products/:product_id/items, and click a row,
        // 2) Create Item page via Edit Product -> Add Item button - products/:id/items/create
        const item = pick(this.state, resourceFields.items.map(item => item.key));
        item[field.key] = inputVal;

        this.fieldVerificationForItems(inputVal, field, item);
        return;
      }
      const verifyEditProductAndCategory = (resource === 'products' || resource === 'categories') && !subResource && this.props.type === 'edit';
      // For the regular product fields in Edit Product /products/:id/edit, not the item fields in Collapsible Item
      // Also checking the category fields
      if (verifyEditProductAndCategory) {
        this.fieldVerification(inputVal, field);
      }
    }
    this.hideFields(resources, resource, fieldName);
  };

  makeItemNameFromProductAndAttributeValue = (product, item) => (`${product.name ? `${product.name} ` : ''}${item.attribute_value ? `${item.attribute_value}` : ''}`)

  /**
   * Searchable inputs use the `react-select` package, and operate differently from the Material UI multi-select
   */
  onChangeSearchableInput = (value, stateKey, isUserRestriction) => {
    const finalValue = stateKey === 'productItems' && !value ? [] : value;
    this.setState({ [stateKey]: finalValue });
    // eslint-disable-next-line no-unused-expressions
    isUserRestriction && this.setState({ userIdsToNames: finalValue });
  }

  showCoordinatesErrorAndDisableSaveButton = (prunedResource, index) => {
    const { coordinateString } = prunedResource;
    if (coordinateString && isString(coordinateString)) return;
    const { isFieldInvalid, invalidFieldMessage } = this.state;

    let isFieldInvalidCopy = isFieldInvalid.slice();
    const invalidFieldMessageCopy = invalidFieldMessage.slice();
    const errorMessage = this.getErrorMessage(index, resourceFields.zones[index]);
    const showErrorArgs = {
      fieldIndex: index, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
    };
    this.showValidationErrorAndDisableSave(showErrorArgs);
  }

  convertMultiSelectOptionsToDatabaseFormat = (field, selectedOptions) => {
    if (field === 'searchableCouponRestrictions') {
      const sorted = sortBy(selectedOptions, ['label', 'value']);
      const valueOnly = selectedOptions.map(option => `${option.value}`);
      return valueOnly.join(',');
    }
    if (['payAtDoorOptions', 'stringMultiSelectCouponRestriction'].includes(field)) {
      const valueOnly = selectedOptions.map(option => `${option.value}`);
      return valueOnly.join(',');
    }
    if (field === 'tierItems') {
      const sorted = sortBy(selectedOptions, ['label', 'value']);
      const idsOnly = sorted.map(option => `${option.value}`);
      return idsOnly;
    }
  }

  /**
   * Gathers the isDefault values from the version of the items in the Redux store, and
   * also adds the isDefault value for an item you're creating.
   * This is for /products/:id/items/:item_id/edit and /products/:id/items/:item_id/create,
   * which don't have the all the other items' isDefault values in their component state
   */
  getAllItemsDefaultValues = (product) => {
    const { type } = this.props;
    let items = product && product.items ? product.items : [];
    let itemsIsDefaultValues = items.map(item => ({ id: item.id, isDefault: item.isDefault }));
    if (type === 'create') {
      itemsIsDefaultValues.push({ id: 'new', isDefault: this.state.isDefault });
    }

    const indexOfUpdatedItem = itemsIsDefaultValues.findIndex(item => `${item.id}` === `${this.state.id}`);

    if (indexOfUpdatedItem > -1) {
      itemsIsDefaultValues[indexOfUpdatedItem].isDefault = this.state.isDefault;
    }
    return itemsIsDefaultValues;
  }

  /**
   * For /products/:id/items/:item_id/edit and /products/:id/items/:item_id/create,
   * which don't have the all the other items' isDefault values in their component state
   */
  renderInvalidVariationDialogForOldCreateEditItems = () => {
    const {
      resource,
      subResource,
      resourceId,
      subResourceId,
    } = this.props.match.params;
    const { type } = this.props;
    if (resource !== 'products' || !resourceId || subResource !== 'items') return;
    let items = [];
    if (this.props.resources && Array.isArray(this.props.resources.products)) {
      const product = this.props.resources.products.find(prod => `${prod.id}` === `${resourceId}`);
      items = this.getAllItemsDefaultValues(product);
    }

    return (
      <React.Fragment>
        {this.renderInvalidVariationDialog(items)}
      </React.Fragment>
    );
  }

  closeInvalidVariationDialog = () => this.setState({ invalidVariationDialogOpen: false })

  renderInvalidVariationDialog = (items) => {
    if (!items) return;
    const numberOfDefaultItems = utilFunctions.checkAtLeastOneDefaultItem(items);

    return (
      <InvalidVariationDialog
        invalidVariationDialogOpen={this.state.invalidVariationDialogOpen}
        numberOfDefaultItems={numberOfDefaultItems}
        closeDialog={this.closeInvalidVariationDialog}
      />
    );
  }


  showDialogAndDecideReturnEarlyIfNoDefaultItem = () => {
    const { resources } = this.props;
    const { resourceId } = this.props.match.params;
    if (resources && Array.isArray(resources.products)) {
      const product = resources.products.find(prod => `${prod.id}` === `${resourceId}`);
      const items = this.getAllItemsDefaultValues(product);
      const numberOfDefaultItems = utilFunctions.checkAtLeastOneDefaultItem(items);
      // Since both the create and edit item routes implies at least one item exists, an item will always exist that the user can set to default to let the submit happen
      if (numberOfDefaultItems < 1) {
        this.setState({ invalidVariationDialogOpen: true });
      }
      return numberOfDefaultItems === 1;
    }
    // If there's no items to check the isDefault value for, allow the other submit checking logic to continue, which may stop it for other reasons
    return true;
  };

  checkIfNoDefaultItemOnInputChange = (field) => {
    const { resource, resourceId, subResource } = this.props.match.params;
    if (field.key !== 'isDefault' || resource !== 'products' || !resourceId || !subResource) return;
    this.showDialogAndDecideReturnEarlyIfNoDefaultItem();
  }

  assignItemsByRewardType = prunedResource => (this.state.rewardType === rewardTypes.DOLLAR
    ? []
    : this.convertMultiSelectOptionsToDatabaseFormat('tierItems', prunedResource.productItems)
  )

  onClickApplyChanges = async () => {
    const {
      actions, history, apiToken, match, type, resources,
    } = this.props;
    const {
      resource, subResource, subResourceId, resourceId,
    } = match.params;
    const primaryResource = (
      resource === 'categories'
      || resource === 'products'
      || resource === 'taxes'
    )
      ? 'menu'
      : resource;
    const nextRoute = this.getNextRoute(primaryResource);
    const resourcePathForEdit = this.generateEditPath(subResource, resource, resourceId, subResourceId);
    const resourcePathForCreate = (subResource) ? [resource, resourceId, subResource] : [resource];
    let resourcePath = type === 'create' ? resourcePathForCreate : resourcePathForEdit;
    const resourceToLoad = resourceFields[subResource || resource].filter(field => field.loadSeperately);
    const {
      prunedResource,
      isFieldInvalid,
      timeLimitSwitch,
      timeLimits,
      iconSwitch,
      disabledSwitch,
      showNoteSwitch,
      isIconChecked,
      items,
      resourceToUpdate,
    } = this.getStateValuesForSubmit();
    if (resource === 'locations' && prunedResource.holidayHours) {
      prunedResource.holidayHours = prunedResource.holidayHours.map((holiday) => {
        if (holiday.id < 0) {
          holiday.id = 0;
        }
        if (holiday.isClose) {
          holiday.open = null;
          holiday.close = null;
        }
        delete holiday.isClose;
        return holiday;
      });
    }
    if (prunedResource.squareId) {
      prunedResource.squareId = prunedResource.squareId.toUpperCase();
    }

    if (resource === 'coupons' && subResource === 'restrictions') {
      if (searchableRestrictionTypes.includes(this.state.type)) {
        prunedResource.value = this.convertMultiSelectOptionsToDatabaseFormat('searchableCouponRestrictions', prunedResource.value);
        prunedResource.addToMatchedItems = true;
      }
      if (this.state.type === 'DAYS_OF_WEEK') {
        prunedResource.value = this.convertMultiSelectOptionsToDatabaseFormat('stringMultiSelectCouponRestriction', prunedResource.value);
      }
      if (this.state.type === 'DELIVERY_TYPE') {
        prunedResource.value = this.convertMultiSelectOptionsToDatabaseFormat('stringMultiSelectCouponRestriction', prunedResource.value);
      }
      if (['START_DATETIME', 'END_DATETIME'].includes(this.state.type)) {
        prunedResource.value = this.state.value.toISOString();
      }
      if (['START_TIME_OF_DAY', 'END_TIME_OF_DAY'].includes(this.state.type)) {
        prunedResource.value = this.state.value.format('HH:mm');
      }
      if (['USERS'].includes(this.state.type) && this.state.duplicatedUserIds && this.state.duplicatedUserIds[0]) {
        return;
      }
    }
    let unverifiedIndices = this.getUnverifiedIndices(subResource || resource, prunedResource);

    // Stop submit if any coupon restriction fields are empty
    if (resource === 'coupons' && subResource === 'restrictions'
      && (unverifiedIndices.includes(restrictionValueIndex) || unverifiedIndices.includes(restrictionTypeIndex))) {
      return;
    }
    // Stop submitting if the coordinates field for delivery zones has a validation error
    const coordinatesIndex = resourceFields.zones.findIndex(val => val.key === 'coordinates');
    if (subResource === 'zones' && unverifiedIndices.includes(coordinatesIndex)) {
      this.showCoordinatesErrorAndDisableSaveButton(prunedResource, coordinatesIndex);
      return;
    }

    const allLocations = get(this.props, 'resources.locations');

    if (type === 'edit') {
      if (resource === 'products' && !subResource) {
        if (unverifiedIndices.length > 0) return;
        const areItemsInvalid = Array.isArray(this.state.items) ? utilFunctions.areVariationsInvalid(this.state.items) : [false];

        // You can set items' isDefault status from this product page as it loads the CollapsibleItem component
        const numberOfDefaultItems = utilFunctions.checkAtLeastOneDefaultItem(this.state.items);
        if (numberOfDefaultItems !== 1 || (Array.isArray(this.state.items) && this.state.items.length === 0) || !every(areItemsInvalid, elem => !elem)) {
          this.setState({ invalidVariationDialogOpen: true });
          return;
        }
      }
      // For the older /products/:id/items/:item_id/edit route
      if (resource === 'products' && subResource === 'items') {
        const shouldContinue = this.showDialogAndDecideReturnEarlyIfNoDefaultItem();
        if (!shouldContinue) return;
      }

      if (timeLimits && timeLimits.length > 0 && timeLimits[0].daysOfWeek.length > 0) {
        if (!timeLimitSwitch) {
          timeLimits.forEach(async (timeLimit) => {
            await actions.deleteResource(apiToken, ...[...resourcePath, 'time-limits', timeLimit.id]);
          });
        } else {
          this.state.deletedTimeLimits.forEach(async (timeLimit) => {
            if (timeLimit.id) {
              await actions.deleteResource(apiToken, ...[...resourcePath, 'time-limits', timeLimit.id]);
            }
          });
          timeLimits.forEach(async (timeLimit) => {
            if (timeLimit.id) {
              await actions.updateResource(apiToken, timeLimit, ...[...resourcePath, 'time-limits', timeLimit.id]);
            } else {
              await actions.addResource(apiToken, timeLimit, ...[...resourcePath, 'time-limits']);
            }
          });
        }
      }
      if (resourceToUpdate.icons && !iconSwitch) {
        resourceToUpdate.icons = [];
      }
      if (resource === 'users' && !subResource) {
        await actions.updateResource(apiToken, prunedResource, ...[...resourcePath, 'admin']);
      } else {
        if (resource === 'products' && prunedResource.locations) {
          const allLocations = get(this.props, 'resources.locations');
          const finalLocationIds = FormSubmits.prepareProductLocationsAsIds(prunedResource.locations, allLocations);
          prunedResource.locations = finalLocationIds;
        }
        if (resource === 'products' && prunedResource.images && !Array.isArray(prunedResource.images)) {
          prunedResource.images = { src: prunedResource.images };
          let imageArray = [];
          imageArray.push(prunedResource.images);
          prunedResource.images = imageArray;
        } else if (resource === 'categories' && Array.isArray(prunedResource.image) && prunedResource.image.length === 0) {
          prunedResource.image = null;
        }
        const hasPayAtDoorOptions = resource === 'locations' && prunedResource.payAtDoorOptions && Array.isArray(prunedResource.payAtDoorOptions);
        if (hasPayAtDoorOptions) {
          prunedResource.payAtDoorOptions = this.convertMultiSelectOptionsToDatabaseFormat('payAtDoorOptions', prunedResource.payAtDoorOptions);
        }
        if (resource === 'locations' && subResource !== 'zones' && !!prunedResource.squareId && resources && Array.isArray(resources.locations)) {
          if (unverifiedIndices.length > 0) return;
          const originalLocation = this.props.resources.locations.find(location => `${location.id}` === `${resourceId}`);
          const originalSquareId = originalLocation && originalLocation.squareId ? originalLocation.squareId : null;
          const newSquareId = prunedResource.squareId;
          const originalCurrency = get(originalLocation, 'currencyCode', null);
          const newCurrency = get(prunedResource, 'currencyCode', null);
          if ((newSquareId !== originalSquareId) || (newCurrency !== originalCurrency)) {
            this.editLocationAndSquareServer(apiToken, prunedResource, resourceId);
            return;
          }
          // Uses the general update resource action below otherwise
        }

        if (resource === 'products' && subResource === 'items' && type === 'edit') {
          if (prunedResource.hasOwnProperty('out-of-stock')) {
            prunedResource['out-of-stock'] = OutOfStockAPIFormat.getAPIFormat(prunedResource['out-of-stock'], allLocations);
            await actions.updateResource(apiToken, prunedResource['out-of-stock'], 'products', resourceId, 'items', subResourceId, 'out-of-stock');
            delete prunedResource['out-of-stock'];
          }
          if (prunedResource.hasOwnProperty('customizations')) {
            const options = get(prunedResource, 'customizations.options', null);
            if (options) {
              const optionsCopy = cloneDeep(options);
              prunedResource.customizations.options = utilFunctions.removeKeysFromObjectArray(optionsCopy, ['customizations', 'outOfStockLocations']);
            }
          }
        }
        if (prunedResource.outOfStock && Array.isArray(prunedResource.outOfStock)) {
          prunedResource.outOfStock = OutOfStockAPIFormat.getAPIFormat(prunedResource.outOfStock, allLocations);
          if (resource === 'products') {
            await actions.updateResource(apiToken, prunedResource.outOfStock, 'products', resourceId, 'out-of-stock');
          }
          if (resource === 'customizations' && subResource === 'options') {
            await actions.updateResource(apiToken, prunedResource.outOfStock, 'customizations', resourceId, 'options', subResourceId, 'out-of-stock');
          }
          // Edit products' out of stock status through `products/:id/out-of-stock` route. The normal backend edit item route does not accept an `outOfStock` param.
          delete prunedResource.outOfStock;
        }
        if (prunedResource.hasOwnProperty('outOfStock') && (typeof prunedResource.outOfStock === 'undefined' || prunedResource.outOfStock === null)) {
          delete prunedResource.outOfStock;
        }
        // safari check for hours in locations
        if (resource === 'locations' && prunedResource.hours) {
          prunedResource.hours = HoursUtils.consolidateHoursRecords(prunedResource.hours);
          for (let i = 0; i < prunedResource.hours.length; i++) {
            prunedResource.hours[i] = HoursUtils.getLeadingZeroTimes(prunedResource.hours[i]);
          }
        }

        if (resource === 'tiers' && Array.isArray(prunedResource.productItems)) {
          prunedResource.productItems = this.assignItemsByRewardType(prunedResource);
        }
        // The API expects null instead of an empty array for reward tiers with no images
        if (resource === 'tiers' && Array.isArray(prunedResource.image) && prunedResource.image.length === 0) {
          prunedResource.image = null;
        }

        if (resource === 'customizations' && Array.isArray(prunedResource.options)) {
          const optionsCopy = cloneDeep(prunedResource.options);
          prunedResource.options = utilFunctions.removeKeysFromObjectArray(optionsCopy, ['customizations', 'outOfStockLocations', 'out-of-stock']);
        }

        if (resource === 'locations') {
          this.addOrUpdateLocationConfiguration(resourceId, this.state);
        }
        // if CANCELED choosen set state isDeleteConfirmDialogOpen to true, to open 2 step verification
        if (resource === 'orders' && prunedResource.orderStatus === 'CANCELED') {
          this.toggleCancelOrderConfirmDialog();
          return;
        }
        // Update resource default case
        await actions.updateResource(apiToken, prunedResource, ...resourcePath);
      }
      if (resource === 'customizations' && !subResource && Array.isArray(prunedResource.productItems)) {
        const { originalAttachedItems, allItemCustomizationsAndProductIds } = this.state;
        const setItemsArgs = {
          actions,
          apiToken,
          resourceId,
          originalAttachedItems,
          allItemCustomizationsAndProductIds,
          customization: prunedResource,
        };
        await FormSubmits.bulkSetItemsOfOneCustomization(setItemsArgs);
      }
      try {
        /**
         * If on the Edit Product Page, update associated
         * items, customizations, and includedOptions
         */
        if (resource === 'products' && subResource !== 'items') {
          if (items) {
            const updateAllItemsPath = [...resourcePath, 'items'];
            const itemsWithAPIOutOfStockFormat = items.map((item) => {
              const itemClone = cloneDeep(item);
              const apiFormatOutOfStockLocations = OutOfStockAPIFormat.getAPIFormatForUpdateAllItems(item['out-of-stock'], allLocations);

              delete itemClone['out-of-stock'];
              itemClone.outOfStockLocations = apiFormatOutOfStockLocations;

              return itemClone;
            });
            let arrayOfPositions = [];
            for (let i = 0; i < itemsWithAPIOutOfStockFormat.length; i++) {
              if (itemsWithAPIOutOfStockFormat[i].hasOwnProperty('position') && itemsWithAPIOutOfStockFormat[i].position !== '' && itemsWithAPIOutOfStockFormat[i].position !== null) {
                arrayOfPositions.push(itemsWithAPIOutOfStockFormat[i].position);
              }
            }
            let maxPosition = arrayOfPositions.length === 0 ? 0 : Math.max(...arrayOfPositions);
            for (let indexOfPosition = 0; indexOfPosition < itemsWithAPIOutOfStockFormat.length; indexOfPosition++) {
              if (!(itemsWithAPIOutOfStockFormat[indexOfPosition].hasOwnProperty('position')) || itemsWithAPIOutOfStockFormat.position === '' || itemsWithAPIOutOfStockFormat.position === null) {
                itemsWithAPIOutOfStockFormat[indexOfPosition].position = maxPosition + 1;
                maxPosition = maxPosition + 1;
              }
            }
            await actions.updateResource(apiToken, itemsWithAPIOutOfStockFormat, ...updateAllItemsPath);
          }
        }
        // update resources that load seperately
        if (resourceToLoad.length > 0) {
          const locations = get(this.props, 'resources.locations', []);
          await Promise.all(resourceToLoad.map((resource) => {
            const fieldKey = resource.key;
            const uneditedFieldValueFromState = resourceToUpdate[fieldKey];
            const finalValue = fieldKey === 'locations'
              ? FormSubmits.useEmptyArrayIfAllLocations(uneditedFieldValueFromState, locations)
              : uneditedFieldValueFromState;

            if (finalValue) {
              return actions.updateResource(apiToken, finalValue, ...resourcePath, fieldKey);
            }
          }));
        }

        if (resource === 'products') {
          history.push(nextRoute);
        } else {
          history.goBack();
        }
      } catch (e) {
        console.log('error: ', e);
        // Sentry.captureException(new Error('Fail on updating associated items, customizations or includedOptions'));
      }
    } else if (type === 'create') {
      /**
       * if need to create timeLimit first create resoure then use created id to create its time limit
       * finally update that category
       */
      const pathname = this.props.location && this.props.location.pathname.toString();
      if (pathname === '/products/create') {
        const { product: { productItems } } = this.state;
        const numberOfDefaultItems = utilFunctions.checkAtLeastOneDefaultItem(productItems);
        const areVariationsInvalid = utilFunctions.areVariationsInvalid(productItems);
        // If all values in areVariationsInvalid are false, you can submit the product item
        if (numberOfDefaultItems < 1 || productItems.length === 0 || (Array.isArray(areVariationsInvalid) && !every(areVariationsInvalid, elem => !elem))) {
          this.setState({ invalidVariationDialogOpen: true });
          return;
        }
      }
      if (resource === 'products' && subResource === 'items' && resourceId) {
        const shouldContinue = this.showDialogAndDecideReturnEarlyIfNoDefaultItem();
        if (!shouldContinue) return;
      }
      if (unverifiedIndices.length === 0) {
        if (resource === 'locations' && !['zones', 'catering-zones'].includes(subResource) && prunedResource.squareId !== null && prunedResource.squareId !== '') {
          const squareServer = { squareId: prunedResource.squareId, currencyCode: prunedResource.currencyCode };
          actions.addResource(apiToken, squareServer, 'square-servers').then(async (res) => {
            if (res.error) return;

            // to remove currencyCode and squareId
            const { currencyCode, squareId, ...location } = prunedResource;
            const squareServerId = res.response.id;

            // remove tempId from location.hours
            (location.hours || []).forEach(hour => delete hour.tempId);

            resourcePath = ['locations', 'square-server', squareServerId];
            await actions.addResource(apiToken, location, ...resourcePath).then((newLocation) => {
              const newLocationID = newLocation.response.id;
              this.addOrUpdateLocationConfiguration(newLocationID, prunedResource);
            });
            history.push(nextRoute);
          });
        } else if (resource === 'products') {
          const pathname = this.props.location && this.props.location.pathname.toString();
          if (pathname === '/products/items/create') {
            history.push({
              pathname: '/products/create',
              state: {
                product: this.state.product,
                categories: history.location.state.categories,
              },
            });
          } else if (subResource !== 'items') {
            const {
              iconSwitch, isIconChecked, disabledSwitch, showNoteSwitch, productItems, ...product
            } = this.state.product;
            if (product.images && product.images.length) {
              product.images = { src: product.images };
              let imageArray = [];
              imageArray.push(product.images);
              product.images = imageArray;
            } else {
              product.images = [];
            }

            let locations = undefined;

            const allLocations = get(this.props, 'resources.locations');
            if (product.locations) {
              locations = product.locations;
              let locationIds = product.locations.map(location => location.id);
              product.locations = locationIds;
            }

            await actions.addResource(apiToken, product, ...resourcePath).then(async (res) => {
              if (res.error) return;
              const { outOfStock } = this.state;
              if (res && res.response && res.response.id && outOfStock && Array.isArray(outOfStock) && outOfStock.length > 0) {
                const targetProductId = res.response.id;
                const APIFormatOutOfStock = OutOfStockAPIFormat.getAPIFormat(outOfStock, allLocations);
                const createOutOfStockProductRes = await actions.updateResource(apiToken, APIFormatOutOfStock, `products/${targetProductId}/out-of-stock`);
              }
              const id = res.response.id;
              let fieldsToPick = [];
              resourceFields.items.map((field) => {
                fieldsToPick.push(field.key);
              });
              if (timeLimitSwitch) {
                const timeLimitResPath = [resource, res.response.id];
                await actions.addResource(apiToken, timeLimits[0], ...[...timeLimitResPath, 'time-limits']);
                actions.updateResource(apiToken, prunedResource, ...timeLimitResPath);
              }
              productItems.forEach(async (productItem) => {
                const item = pick(productItem, fieldsToPick);
                const apiFormatOutOfStockLocations = OutOfStockAPIFormat.getAPIFormat(productItem['out-of-stock'], allLocations);
                if (item.hasOwnProperty('out-of-stock')) {
                  delete item['out-of-stock'];
                }
                await actions.addResource(apiToken, item, ...resourcePath, id, 'items').then(async (res) => {
                  if (res.error) return;
                  const itemId = res.response.id;
                  const createItemPath = [...resourcePath, id, 'items', itemId];
                  const customizations = item.customizations;
                  if (productItem['out-of-stock']) {
                    await actions.updateResource(apiToken, apiFormatOutOfStockLocations, ...createItemPath, 'out-of-stock');
                  }
                  if (customizations !== undefined) {
                    await actions.updateResource(apiToken, customizations, ...createItemPath, 'customizations').then(async (res) => {
                      if (res.error) return;
                      const options = item.includedOptions;
                      if (options !== undefined) {
                        await actions.updateResource(apiToken, options, ...createItemPath, 'includedOptions');
                      }
                    });
                  }
                });
              });

              if (locations) {
                product.locations = FormSubmits.useEmptyArrayIfAllLocations(locations, allLocations);
              }
              if (resourceToLoad.length > 0) {
                await Promise.all(resourceToLoad.map((resource) => {
                  if (product[resource.key]) {
                    actions.updateResource(apiToken, product[resource.key], ...resourcePath, id, resource.key);
                  }
                }));
              }
              history.push(nextRoute);
            });
            product.locations = FormSubmits.useEmptyArrayIfAllLocations(locations, allLocations);
          } else {
            let fieldsToPick = [];
            resourceFields.items.map((field) => {
              fieldsToPick.push(field.key);
            });
            const item = pick(this.state, fieldsToPick);
            // The API endpoint for items returns a 400 Bad Request if you send it an out-of-stock key. Send out-of-stock to the /products/:id/items/:item_id/out-of-stock endpoint
            if (item.hasOwnProperty('out-of-stock')) {
              delete item['out-of-stock'];
            }
            const apiFormatOutOfStockLocations = OutOfStockAPIFormat.getAPIFormat(this.state['out-of-stock'], allLocations);
            await actions.addResource(apiToken, item, ...resourcePath).then(async (res) => {
              if (res.error) return;
              const itemId = res.response.id;
              const updateOutOfStockRes = await actions.updateResource(apiToken, apiFormatOutOfStockLocations, ...resourcePath, itemId, 'out-of-stock');
              const createItemPath = [...resourcePath, itemId];
              const customizations = item.customizations;
              if (customizations !== undefined && customizations !== null) {
                await actions.updateResource(apiToken, customizations, ...createItemPath, 'customizations').then(async (res) => {
                  if (res.error) return;
                  const options = item.includedOptions;
                  if (options !== undefined && customizations !== null) {
                    await actions.updateResource(apiToken, options, ...createItemPath, 'includedOptions');
                  }
                });
              }
            });
            // Reload the page if nextRoute returns to an EDIT page
            if (nextRoute.split('/')[nextRoute.split('/').length - 1] === 'edit') {
              history.push(nextRoute);
              if (resource === 'products') {
                const productPageState = JSON.parse(sessionStorage.getItem('tempProductState'));
                sessionStorage.removeItem('tempProductState');

                const { resources, match } = this.props;
                const findProductArgs = { resources, match };
                const product = utilFunctions.findEntityByID(findProductArgs);
                productPageState.items = product.items;
                this.setState(productPageState);
              } else {
                this.setState(this.createState());
              }
            } else {
              history.push(nextRoute);
            }
          }
        } else {
          if (resource === 'locations' && subResource === 'zones' && type === 'create') {
            prunedResource.isDisabled = false;
            prunedResource.isDeleted = false;
          }
          if (resource === 'categories' && Array.isArray(prunedResource.image) && prunedResource.image.length === 0) {
            prunedResource.image = null;
          }
          const hasPayAtDoorOptions = resource === 'locations' && prunedResource.payAtDoorOptions && Array.isArray(prunedResource.payAtDoorOptions);
          if (hasPayAtDoorOptions) {
            prunedResource.payAtDoorOptions = this.convertMultiSelectOptionsToDatabaseFormat('payAtDoorOptions', prunedResource.payAtDoorOptions);
          }
          const { outOfStock } = prunedResource;
          if (resource === 'customizations' && subResource === 'options') {
            if (prunedResource.hasOwnProperty('outOfStock')) {
              delete prunedResource.outOfStock;
            }
          }
          // safari check for hours in locations
          if (resource === 'locations' && prunedResource.hours) {
            prunedResource.hours = HoursUtils.consolidateHoursRecords(prunedResource.hours);
            for (let i = 0; i < prunedResource.hours.length; i++) {
              prunedResource.hours[i] = HoursUtils.getLeadingZeroTimes(prunedResource.hours[i]);
            }
          }
          if (resource === 'tiers') {
            prunedResource.productItems = this.assignItemsByRewardType(prunedResource);
          }
          if (resource === 'customizations' && !subResource && type === 'create') {
            // Temporary. Cannot use current API endpoints to bulk set items on a customization when creating customization, because there's no customization id yet.
            delete prunedResource.productItems;
          }
          actions.addResource(apiToken, prunedResource, ...resourcePath).then(async (res) => {
            if (res.error) return;
            if (resource === 'customizations' && subResource === 'options') {
              const apiFormatOutOfStock = OutOfStockAPIFormat.getAPIFormat(outOfStock, allLocations);
              actions.updateResource(apiToken, apiFormatOutOfStock, resource, resourceId, subResource, `${res.response.id}`, 'out-of-stock');
            }
            if (timeLimitSwitch) {
              const timeLimitResPath = [resource, res.response.id];
              await actions.addResource(apiToken, timeLimits[0], ...[...timeLimitResPath, 'time-limits']);
              actions.updateResource(apiToken, prunedResource, ...timeLimitResPath);
            }

            if (resource === 'locations') {
              const newLocationID = res.response.id;
              this.addOrUpdateLocationConfiguration(newLocationID, prunedResource);
            }

            if (resourceToLoad.length > 0) {
              resourceToLoad.map((resource) => {
                if (resourceToUpdate[resource.key]) {
                  actions.updateResource(apiToken, prunedResource[resource.key], ...resourcePath, res.response.id, resource.key);
                }
              });
            }
            // Reload the page if nextRoute returns to an EDIT page
            if (nextRoute.split('/')[nextRoute.split('/').length - 1] === 'edit') {
              history.push(nextRoute);
              this.setState(this.createState());
            } else {
              history.push(nextRoute);
            }
          });
        }
      } else {
        let isFieldInvalidCopy = isFieldInvalid.slice().fill(false);
        unverifiedIndices = this.getUnverifiedIndices(subResource || resource, prunedResource);
        unverifiedIndices.map((index) => {
          isFieldInvalidCopy[index] = true;
        });
        this.setState({
          isFieldInvalid: isFieldInvalidCopy,
        });
      }
    }
  };

  addOrUpdateLocationConfiguration = (locationID, stateSnapshot) => {
    const { apiToken, actions } = this.props;
    ['DELIVERY_WINDOW', 'PICKUP_WINDOW'].forEach((code) => {
      const payload = {
        location: { id: locationID },
        code,
        value: stateSnapshot[code],
        dataType: 'LONG',
        isVisibleToAdmin: true,
        isVisibleToMobile: true,
      };
      actions.addResource(apiToken, payload, 'configuration');
    });
  }

  editLocationAndSquareServer = (apiToken, prunedResource, resourceId) => {
    const { history, actions } = this.props;
    const { currencyCode, squareId, ...location } = prunedResource;
    const newSquareServer = { squareId, currencyCode };
    actions.addResource(apiToken, newSquareServer, 'square-servers').then(async (res) => {
      if (res.error) return;
      const squareServerId = res.response.id;
      const resourcePath = ['locations', resourceId, 'square-server', squareServerId];
      await actions.updateResource(apiToken, location, ...resourcePath);
      const nextRoute = this.getNextRoute('locations');
      history.push(nextRoute);
    });
  }

  // We should see if updating any old-style empty hours with all values as NULL will be enough to make the hours pass validation
  // We still want to find hours values that are invalid for any other reason
  updateInitialHoursThenValidate = (hours) => {
    const updatedHours = HoursUtils.initializeHours(hours);
    const validateHoursFunc = () => this.hoursValidation(updatedHours);
    this.setState({
      hours: updatedHours,
    }, validateHoursFunc);
  }

  hoursValidation = (hourObjs) => {
    let invalidFieldMessageCopy = this.state && this.state.invalidFieldMessage ? this.state.invalidFieldMessage.slice() : [];
    let isFieldInvalidCopy = this.state && this.state.isFieldInvalid ? this.state.isFieldInvalid.slice() : [];
    let isThisFieldInvalid = false;

    const hoursTabsWithErrors = { business: false, delivery: false, pickup: false };

    for (let i = 0; i < hourObjs.length; i++) {
      const hourRecord = hourObjs[i];

      const { isAllHourTypesValid, doTabsHaveErrors } = HoursUtils.getIsHourValidResults(hourRecord);
      if (!isAllHourTypesValid) isThisFieldInvalid = true;
      doTabsHaveErrors.forEach(([tab, hasErrorResult]) => {
        const tabAlreadyHasErrors = hoursTabsWithErrors[tab];
        const tabNowHasErrors = tabAlreadyHasErrors || hasErrorResult;
        hoursTabsWithErrors[tab] = tabNowHasErrors;
      });
    }

    const { tabsWithOverlaps, hoursHaveOverlaps } = HoursUtils.getHasOverlapsSummary(hourObjs);
    tabsWithOverlaps.forEach(([tab, hasErrorResult]) => {
      const tabAlreadyHasErrors = hoursTabsWithErrors[tab];
      const tabNowHasErrors = tabAlreadyHasErrors || hasErrorResult;
      hoursTabsWithErrors[tab] = tabNowHasErrors;
    });
    if (hoursHaveOverlaps) isThisFieldInvalid = true;

    const updateValidationArgs = {
      isThisFieldInvalid,
      fieldIndex: hoursIndex,
      isFieldInvalidCopy,
      invalidFieldMessageCopy,
    };

    this.updateValidationAndSaveButton(updateValidationArgs);
    this.setState({ hoursTabsWithErrors });
  }

  deliveryTimeValidation = (deliveryService, val, field) => {
    const isFieldInvalidCopy = this.state.isFieldInvalid.slice();
    const invalidFieldMessageCopy = this.state.invalidFieldMessage.slice();
    const errorMessage = `With ${deliveryService} enabled, the delivery time must be 30 minutes more than the pickup time.`;
    const { deliveryTime, pickupTime } = this.state;
    if (!isNaN(val) && val !== '') {
      const intVal = parseInt(val);
      if (field.key === 'deliveryTime' && pickupTime) {
        if (intVal - pickupTime >= 30) {
          this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: pickupTimeIndex, isFieldInvalidCopy });
          this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: deliveryTimeIndex, isFieldInvalidCopy });
        } else {
          const showErrorArgs = {
            fieldIndex: deliveryTimeIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
          };
          this.showValidationErrorAndDisableSave(showErrorArgs);
        }
      } else if (field.key === 'pickupTime' && deliveryTime) {
        if (deliveryTime - intVal >= 30) {
          this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: deliveryTimeIndex, isFieldInvalidCopy });
          this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: pickupTimeIndex, isFieldInvalidCopy });
        } else {
          const showErrorArgs = {
            fieldIndex: pickupTimeIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
          };
          this.showValidationErrorAndDisableSave(showErrorArgs);
        }
      }
    } else if (val === '') {
      if (field.key === 'deliveryTime') {
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: deliveryTimeIndex, isFieldInvalidCopy });
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: pickupTimeIndex, isFieldInvalidCopy });
      } else if (field.key === 'pickupTime') {
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: pickupTimeIndex, isFieldInvalidCopy });
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex: deliveryTimeIndex, isFieldInvalidCopy });
      }
    }
  }

  enableSaveIfAllFieldsCorrect = (isFieldInvalidCopy) => {
    const { type, match: { params } } = this.props;
    const { resource, subResource } = params;
    if (resource === 'products' && !subResource && type === 'edit') {
      const { items } = this.state;
      const areAnyItemsInvalid = utilFunctions.areVariationsInvalid(items);
      const productIsFieldInvalid = this.state.isFieldInvalid;

      if (every(areAnyItemsInvalid, isInvalid => !isInvalid) && every(productIsFieldInvalid, isInvalid => !isInvalid)) {
        this.setState({
          disableSaveButton: false,
        });
      }
      return;
    }

    if (every(isFieldInvalidCopy, isInvalid => !isInvalid)) {
      this.setState({
        disableSaveButton: false,
      });
    }
  }

  updateValidationAndEnableSaveWhenCorrect = ({
    fieldIndex,
    isFieldInvalidCopy,
    isExpandedItem,
    itemId,
    field,
  }) => {
    const isFieldInvalidStateKey = typeof isExpandedItem === 'boolean' ? `item${itemId}IsFieldInvalid` : 'isFieldInvalid';
    const key = typeof isExpandedItem === 'boolean' ? field.key : fieldIndex;
    isFieldInvalidCopy[key] = false;

    const checkCanEnableSave = () => this.enableSaveIfAllFieldsCorrect(isFieldInvalidCopy);
    this.setState({
      [isFieldInvalidStateKey]: isFieldInvalidCopy,
    }, checkCanEnableSave);
  }

  showValidationErrorAndDisableSave = ({
    fieldIndex,
    isFieldInvalidCopy,
    invalidFieldMessageCopy,
    errorMessage,
    isExpandedItem,
    itemId,
    field,
  }) => {
    const isFieldInvalidStateKey = typeof isExpandedItem === 'boolean' ? `item${itemId}IsFieldInvalid` : 'isFieldInvalid';
    const invalidFieldMessageStateKey = typeof isExpandedItem === 'boolean' ? `item${itemId}InvalidFieldMessage` : 'invalidFieldMessage';
    const key = typeof isExpandedItem === 'boolean' ? field.key : fieldIndex;
    isFieldInvalidCopy[key] = true;
    invalidFieldMessageCopy[key] = errorMessage;

    this.setState({
      [isFieldInvalidStateKey]: isFieldInvalidCopy,
      [invalidFieldMessageStateKey]: invalidFieldMessageCopy,
      disableSaveButton: true,
    });
  }

  updateValidationAndSaveButton = ({
    isThisFieldInvalid,
    field,
    fieldIndex,
    isFieldInvalidCopy,
    invalidFieldMessageCopy,
    errorMessage,
    isExpandedItem,
    itemId,
  }) => {
    if (isThisFieldInvalid) {
      const showErrorArgs = {
        fieldIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage, isExpandedItem, itemId, field,
      };
      this.showValidationErrorAndDisableSave(showErrorArgs);
    } else {
      const updateIsValidArgs = {
        fieldIndex, isFieldInvalidCopy, isExpandedItem, itemId, field,
      };
      this.updateValidationAndEnableSaveWhenCorrect(updateIsValidArgs);
    }
  }

  fieldVerificationForItems = (val, field, wholeResource, isExpanded) => {
    const { resource, subResource } = this.props.match.params;
    const { type, location: { pathname } } = this.props;
    const { id } = wholeResource;

    let isFieldInvalidCopy = [];
    let invalidFieldMessageCopy = [];

    // For the /products/:id/items/:id/edit route
    if (resource === 'products' && subResource === 'items' && !this.state[`item${id}IsFieldInvalid`] && this.state.isFieldInvalid && this.state.invalidFieldMessage) {
      isFieldInvalidCopy = this.state.isFieldInvalid.slice();
      invalidFieldMessageCopy = this.state.invalidFieldMessage.slice();
    } else if (Array.isArray(this.state[`item${id}IsFieldInvalid`]) && Array.isArray(this.state[`item${id}InvalidFieldMessage`])) {
      isFieldInvalidCopy = this.state[`item${id}IsFieldInvalid`].slice();
      invalidFieldMessageCopy = this.state[`item${id}InvalidFieldMessage`].slice();
      // For CollapsibleItems
    } else if (
      this.state[`item${id}IsFieldInvalid`] && this.state[`item${id}IsFieldInvalid`].hasOwnProperty('attribute_name')
      && this.state[`item${id}InvalidFieldMessage`] && this.state[`item${id}InvalidFieldMessage`].hasOwnProperty('attribute_name')
    ) {
      // These objects do not store nested objects -> shallow copying is enough
      isFieldInvalidCopy = Object.assign({}, this.state[`item${id}IsFieldInvalid`]);
      invalidFieldMessageCopy = Object.assign({}, this.state[`item${id}InvalidFieldMessage`]);
    }

    let isThisFieldInvalid = false;
    if (pathname === '/products/items/create' || (resource === 'products' && subResource === 'items') || (resource === 'products' && type === 'edit')) {
      if (field.isRequired && field.type !== 'boolean' && !val) {
        isThisFieldInvalid = true;
      }
      if (field.isRequired && field.type === 'boolean' && ![true, false].includes(val)) {
        isThisFieldInvalid = true;
      }
      // Index is used when not editing a CollapsibleItem - CollapsibleItems would have changing indexes for each field
      // depending on the expanded/collapsed state. The `isExpanded` parameter being a boolean instead of undefined signals
      // a CollapsibleItem. CollapsibleItems use objects in state to track invalid field status and messages
      // , with keys for each field at the top level.
      let index;
      if (field.key === 'attribute_value') {
        for (const key of ['name', 'attribute_value']) {
          isThisFieldInvalid = !wholeResource[key];
          index = fieldIndexes.items[key];
          const errorMessage = validationErrorMessages.items[key];
          const updateValidationArgs = {
            itemId: id,
            isExpandedItem: isExpanded,
            fieldIndex: index,
            isThisFieldInvalid,
            field,
            isFieldInvalidCopy,
            invalidFieldMessageCopy,
            errorMessage,
          };

          this.updateValidationAndSaveButton(updateValidationArgs);
        }
        return;
      } else if (['isDefault', 'name', 'attribute_name'].includes(field.key)) {
        index = fieldIndexes.items[field.key];
        const errorMessage = validationErrorMessages.items[field.key];
        const updateValidationArgs = {
          itemId: id,
          isExpandedItem: isExpanded,
          fieldIndex: index,
          isThisFieldInvalid,
          field,
          isFieldInvalidCopy,
          invalidFieldMessageCopy,
          errorMessage,
        };
        this.updateValidationAndSaveButton(updateValidationArgs);
        return;
      } else if (field.key === 'price') {
        isThisFieldInvalid = utilFunctions.validatePrice(val);
        index = fieldIndexes.items[field.key];
        const errorMessage = validationErrorMessages.items[field.key];
        const updateValidationArgs = {
          itemId: id,
          isExpandedItem: isExpanded,
          fieldIndex: index,
          isThisFieldInvalid,
          field,
          isFieldInvalidCopy,
          invalidFieldMessageCopy,
          errorMessage,
        };
        this.updateValidationAndSaveButton(updateValidationArgs);
        return;
      }
      // Allow other fields like prep time or points to undergo the normal validation below by type
      index = resourceFields.items.findIndex(rField => rField.key === field.key);
      const numberValidations = FieldValidation.validateNumberTypes(val, field);
      let errorMessage = '';
      if (field.type === 'decimal' && numberValidations.invalidDecimal) {
        isThisFieldInvalid = true;
        errorMessage = `${field.title} should only have two digits after points`;
      } else if (field.type === 'number' && numberValidations.invalidInt) {
        isThisFieldInvalid = true;
        errorMessage = `${field.title} must be a whole number e.g. 1, 2`;
      }
      const updateValidationArgs = {
        itemId: id,
        isExpandedItem: isExpanded,
        fieldIndex: index,
        isThisFieldInvalid,
        field,
        isFieldInvalidCopy,
        invalidFieldMessageCopy,
        errorMessage,
      };
      this.updateValidationAndSaveButton(updateValidationArgs);
    }
  }

  fieldVerification = (val, field) => {
    const { match, location: { pathname }, type } = this.props;
    const { resource, subResource } = match.params;

    // Item Price validation is handled in fieldVerificationForItems, allowing this function to move forward
    // creates a race condition that can re-enable the Save button, although the Save won't go through
    if (resource === 'products' && subResource === 'items' && field.key === 'price') return;
    const resourceType = (subResource === 'view' ? 'customizations' : subResource) || (resource);
    const isValidatingCouponRestrictionsValueField = field.key === 'value' && resource === 'coupons' && subResource === 'restrictions';
    let correctFieldType = '';

    if (isValidatingCouponRestrictionsValueField && !this.state.type) {
      correctFieldType = field.type;
    }
    if (isValidatingCouponRestrictionsValueField && this.state.type) {
      correctFieldType = restricitionTypes.find(elem => elem.value === this.state.type).type;
    }
    if (!isValidatingCouponRestrictionsValueField) {
      correctFieldType = field.type;
    }
    const fields = resourceFields[resourceType];
    const { isFieldInvalid, invalidFieldMessage } = this.state;
    const isFieldInvalidCopy = isFieldInvalid.slice();
    const invalidFieldMessageCopy = invalidFieldMessage.slice();
    let fieldIndex = null;
    fields.map((item, ind) => {
      if (item.key === field.key) {
        fieldIndex = ind;
      }
    });

    if (field.key === 'coordinates') {
      let fieldsToPick = [];
      resourceFields[subResource || resource].map((field) => {
        fieldsToPick.push(field.key);
      });
      let prunedResource = pick(this.state, fieldsToPick);
      const unverifiedIndices = this.validateCoordinates(val, [], field, fieldIndex);
      const coordinatesIndex = resourceFields.zones.findIndex(val => val.key === 'coordinates');
      if (unverifiedIndices.includes(coordinatesIndex)) {
        errorMessage = this.getErrorMessage(fieldIndex, field);
        const showErrorArgs = {
          fieldIndex: coordinatesIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
        };
        this.showValidationErrorAndDisableSave(showErrorArgs);
        return;
      } else {
        this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex, isFieldInvalidCopy });
        return;
      }
    }

    const isCreateOrEditProducts = ((resource === 'products' && type === 'edit' && subResource !== 'items') || pathname === '/products/create');
    const isCategoryDescription = resource === 'categories' && field.key === 'description';
    const isDescriptionAboveMaxChars = MAX_CHAR_DESCRIPTION_RESOURCES.includes(resource) && field.key === 'description' && typeof val === 'string' && val.length > MAX_CHAR_DESCRIBE_TEXTFIELD;

    if (isCreateOrEditProducts || isCategoryDescription) {
      let isThisFieldInvalid = false;
      if ((field.isRequired && !val) || isDescriptionAboveMaxChars) {
        isThisFieldInvalid = true;
      }
      const errorMessage = this.getErrorMessage(fieldIndex, field, val);

      const updateValidationArgs = {
        isThisFieldInvalid, field, fieldIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
      };
      this.updateValidationAndSaveButton(updateValidationArgs);
      return;
    }

    const numberValidations = FieldValidation.validateNumberTypes(val, field);

    let errorMessage = '';

    const { startingPosition } = this.state;
    console.log("file: CreateAndEditResource.jsx | line 2025 | CreateAndEditResource | startingPosition", startingPosition)
    const isPositionInvalid = correctFieldType === 'nonZeroInt' && field.key === 'position'
      && FieldValidation.isPositionInvalid(startingPosition, numberValidations);
    console.log("file: CreateAndEditResource.jsx | line 2027 | CreateAndEditResource | isPositionInvalid", isPositionInvalid)
    if (isPositionInvalid) {
      errorMessage = FieldValidation.getPositionErrorMessage(isPositionInvalid, startingPosition);
      console.log("file: CreateAndEditResource.jsx | line 2031 | CreateAndEditResource | errorMessage", errorMessage)
    } else if (correctFieldType === 'decimal' && numberValidations.invalidDecimal) {
      errorMessage = `${field.title} should only have two digits after points`;
    } else if (field.key === 'widthPercentage' && numberValidations.invalidWidth) {
      errorMessage = 'Width Percentage must be between 0 and 100.';
    } else if (field.key === 'percentage' && numberValidations.invalidTax) {
      errorMessage = 'Tax percentage must be between 0 and 100.';
    } else if (correctFieldType === 'number' && numberValidations.invalidInt) {
      errorMessage = `${field.title} must be a whole number e.g. 1, 2`;
    } else {
      this.updateValidationAndEnableSaveWhenCorrect({ fieldIndex, isFieldInvalidCopy });
      return;
    }
    const showErrorArgs = {
      fieldIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
    };
    this.showValidationErrorAndDisableSave(showErrorArgs);
  }

  getLocationDropdownOptionsForField = (fieldKey, adminLocation) => {
    const locations = get(this.props, 'resources.locations', []);
    // Product Available At Locations
    if (fieldKey === 'locations') return cloneDeep(locations);

    // Out of Stock Locations
    const outOfStockLocations = locations.map((location, ind) => ({
      name: location.name,
      value: location.id,
      id: ind,
      isDisabled: adminLocation && location.id !== adminLocation.id,
    }));
    return outOfStockLocations;
  }

  getDropdownOptions = (field, isSubResource, id) => {
    const { resource, subResource } = this.props.match.params;
    const { admin } = this.props;
    const isLocationAdmin = checkIsLocationAdmin(admin);
    let customizations;
    if (isSubResource === 'items') {
      customizations = this.state.items.filter(item => item.id === id)[0].customizations;
    } else {
      customizations = this.state.customizations;
    }
    if (field.key === 'includedOptions') {
      if (customizations && customizations.length > 0) {
        return utilFunctions.showAvailableOptions(customizations);
      }
      return [];
    }
    if (field.key === 'component') {
      return resourceFields.components;
    }
    if (field.key === 'posIntegration') {
      return resourceFields.posIntegration;
    }
    if (field.key === 'paymentIntegration') {
      return resourceFields.paymentIntegration;
    }
    if (field.key === 'orderTypes') {
      return orderTypes;
    }
    if (field.key === 'currencyCode') {
      return currencyCodes;
    }
    if (field.key === 'reportFrequency') {
      return reportFrequency;
    }
    if (field.key === 'actionType') {
      return couponActionTypes;
    }
    if (field.key === 'type') {
      return restricitionTypes;
    }
    if (field.key === 'rewardType') {
      return tiersRewardType;
    }
    if (field.key === 'category' && this.props.history.location.state) {
      return this.props.history.location.state.categories;
    }
    if (field.key === 'payAtDoorOptions') {
      return payAtDoorOptions;
    }
    if (resource === 'coupons' && field.key === 'value') {
      const { type } = this.state;
      if (!type) return [];
      if (type === 'DAYS_OF_WEEK') return daysOfWeek;
      if (type === 'DELIVERY_TYPE') return deliveryType;
    }
    if ((IdentifyPage.isCreateOrEditProduct(resource) || (IdentifyPage.isCreateOrEditCustOptions(resource, subResource)))
      && fieldsWithSelectAllOption[field.key]
    ) {
      const { locations } = this.props.resources;
      if (!locations) return [];
      let adminLocation = null;

      if (isLocationAdmin && admin) {
        const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);
        adminLocation = !!adminLocationId && locations.find(location => `${location.id}` === `${adminLocationId}`);
      }
      const locationOptions = this.getLocationDropdownOptionsForField(field.key, adminLocation);

      return locationOptions;
    }
    return field.options || this.props.resources[field.dataTable];
  }

  getFieldTypeTag = (fieldType) => {
    switch (fieldType) {
      case 'image':
        return DisplayImages;
      case 'hours':
        return Hours;
      case 'holidayHours':
        return HolidayHours;
      case 'dropdown':
        return Dropdown;
      case 'boolean':
        return CraverRadio;
      case 'text':
      default:
        this.predefinedFieldTypes = ['image', 'hours', 'dropdown', 'boolean', 'holidayHours']; // to avoid unknown props passed down to textfield
        return TextField;
    }
  };

  hideComponent = (field) => {
    const { type } = this.props;
    const { resource, subResource } = this.props.match.params;
    if (field.key === 'isSingleSelectDefault') {
      const { minOptions, maxOptions } = this.state;
      return !(Number(minOptions) === 1 && Number(maxOptions) === 1);
    } else if (field.key === 'isDefault' && this.props.location && this.props.location.pathname.toString() === '/products/items/create') {
      return true;
      // Temporary. Cannot use current API endpoints to bulk set items on a customization when creating customization, because there's no customization id yet.
    } else if (field.key === 'productItems' && resource === 'customizations' && !subResource && type === 'create') {
      return true;
    }
    return false;
  }

  prepareValueForDropdown = (key, value, sourceConstant) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (!value) {
      return [];
    }
    if (isString(value)) {
      const arrayAsJoinedString = value;
      const splitted = arrayAsJoinedString.split(',');

      const correctOptions = sourceConstant.filter((val) => {
        if (splitted.includes(val.value)) return true;
        return false;
      });
      this.setState({ [key]: correctOptions });
    }
    // When on coupon restriction Create/Edit, switching between a (date)time field and a multi-select field
    // passes a moment object into Dropdown.props.data.
    if (!Array.isArray(value)) return [];
  }

  shouldDisableField = (field, isSubResource, requestsLeftToLoad) => {
    if (field.key === 'isDefault') return requestsLeftToLoad > 0;
    return field.isDisabledForLocationAdmins || (isSubResource && requestsLeftToLoad > 0);
  }

  shouldDisableSaveButton = () => {
    const { match, type, requestsLeftToLoad } = this.props;
    const { resource, resourceId, subResource } = match.params;
    // Edit Product page with CollapsibleItems
    if (resource === 'products' && resourceId && !subResource && type === 'edit') {
      return this.state.disableSaveButton || requestsLeftToLoad > 0;
    }
    return this.state.disableSaveButton;
  }

  getOutOfStockLocations = (outOfStockData, locationsTrueDropdownIndexes) => {
    return outOfStockData.map((dropdownOption) => {
      // For product out of stock, the id: <dropdownIndex> can need to be corrected
      const isDropdownOptionId = `${dropdownOption.id}` === `${locationsTrueDropdownIndexes[`a${dropdownOption.value}`]}`;
      if (isDropdownOptionId) return dropdownOption;
      return {
        name: dropdownOption.name,
        value: dropdownOption.value,
        // In a multiselect, the id is the dropdown option index
        id: locationsTrueDropdownIndexes[`a${dropdownOption.value}`],
      };
    });
  }

  loadUsers = (searchTerm) => {
    const { actions, apiToken } = this.props;
    return actions.getSearchedUsers(apiToken, `users?start=0&count=50&q=${searchTerm}`)
      .then((res) => {
        const searchableUsers = getUsers(res);
        this.setState({ searchableUsers });
        return searchableUsers;
    });
  }

  getFieldContent = (field, isSubResource, id) => {
    const {
      loading, actions, apiToken, match, resources, history, type, requestsLeftToLoad, width,
    } = this.props;
    const {
      resource, subResource, resourceId, subResourceId,
    } = match.params;
    const { searchableUsers } = this.state;
    const resourceType = (subResource === 'view' ? 'customizations' : subResource) || (resource);
    const fields = resourceFields[resourceType];

    let fieldIndex = null;
    let fieldType = '';
    let correctAllowMultiple = false;

    const renderingCouponRestrictionValueField = resource === 'coupons' && subResource === 'restrictions' && field.key === 'value';

    if (renderingCouponRestrictionValueField) {
      fieldIndex = restrictionValueIndex;
      const stateType = this.state.type;
      // If no restrictionType is chosen, render the Value TextField from Constants.resourceFields.restrictions
      if (!stateType) {
        fieldType = field.type;
        correctAllowMultiple = field.allowMultiple;
      }
      // If the user chose a restrictionType, instead take fieldType from Constants.restrictionTypes
      if (stateType) {
        const fieldInfoForType = restricitionTypes.find(type => stateType === type.value);
        fieldType = fieldInfoForType.type;
        correctAllowMultiple = fieldInfoForType.allowMultiple;
      }
    }
    if (!renderingCouponRestrictionValueField) {
      fields.map((item, ind) => {
        if (item.key === field.key) {
          fieldIndex = ind;
        }
      });
      fieldType = field.type;
      correctAllowMultiple = field.allowMultiple;
    }

    let isFieldInvalid;
    // For CollapsibleItems
    if (isSubResource === 'items' && this.state[`item${id}IsFieldInvalid`]) {
      isFieldInvalid = this.state[`item${id}IsFieldInvalid`][field.key];
    } else {
      isFieldInvalid = this.state.isFieldInvalid[fieldIndex];
    }

    const FieldType = this.getFieldTypeTag(fieldType);
    const dropdownOptions = this.getDropdownOptions(field, isSubResource, id);
    const pathname = this.props.location && this.props.location.pathname.toString();
    let fieldData;
    let item;

    if (isSubResource === 'items') {
      const locationsTrueDropdownIndexes = {};
      item = this.state.items.filter(item => item.id === id)[0];
      if (['outOfStock', 'out-of-stock'].includes(field.key) && this.props.resources && this.props.resources.locations && Array.isArray(this.props.resources.locations) && this.props.resources.locations.length > 1) {
        const outOfStockData = item[field.key];
        if (!outOfStockData) return [];
        dropdownOptions.forEach((option) => {
          // dropdownOptions for item out-of-stock are each interface { id: <dropdownIndex>, name: <location_name>, value: <location_id }
          locationsTrueDropdownIndexes[`a${option.value}`] = option.id;
        });
        const multiSelectFriendly = outOfStockData.map((location) => {
          // The API returns [{ name: 'locationName', id: <location_id> }]
          if (location.value) return location;
          return {
            name: location.name,
            value: location.id,
            // In a multiselect, the id is the dropdown option index
            id: locationsTrueDropdownIndexes[`a${location.id}`],
          };
        });
        fieldData = multiSelectFriendly;
      } else {
        fieldData = item[field.key];
      }
    } else if (field.key === 'component'
      || field.key === 'customizationView'
      || field.key === 'posIntegration'
      || field.key === 'paymentIntegration'
      || field.key === 'reportFrequency'
      || field.key === 'actionType'
      || field.key === 'type'
      || field.key === 'widthPercentage'
      || field.key === 'rewardType'
      || field.key === 'orderStatus'
    ) {
      fieldData = dropdownOptions.find(item => item.value === this.state[field.key]);
    } else if (resource === 'products' && this.state.product) {
      if (pathname === '/products/create') {
        fieldData = this.state.product[field.key];
      } else if (pathname === '/products/items/create' && this.state.product.productItems) {
        const productItem = this.state.product.productItems.find(item => item.selectedItem === true);
        fieldData = productItem && productItem[field.key];
      } else {
        fieldData = this.state[field.key];
      }
    } else {
      fieldData = this.state[field.key];
    }
    if (field.key === 'outOfStock' && this.props.resources.locations && Array.isArray(this.props.resources.locations) && this.props.resources.locations.length > 1) {
      const locationsTrueDropdownIndexes = {};
      let multiSelectFriendly = [];
      const outOfStockData = this.state.outOfStock;
      const outOfStockLocations = this.state.outOfStockLocations;
      if (Array.isArray(outOfStockData)) {
        dropdownOptions.forEach((option) => {
          // dropdownOptions for outOfStock are each interface { id: <dropdownIndex>, name: <location_name>, value: <location_id> }
          locationsTrueDropdownIndexes[`a${option.value}`] = option.id;
        });
        multiSelectFriendly = this.getOutOfStockLocations(outOfStockData, locationsTrueDropdownIndexes);
      }
      let initialOOSLocations = [];
      if (Array.isArray(outOfStockLocations) && !Array.isArray(outOfStockData)) {
        dropdownOptions.forEach((option) => {
          if (outOfStockLocations.includes(option.value)) {
            initialOOSLocations.push(option);
          }
          locationsTrueDropdownIndexes[`a${option.value}`] = option.id;
        });
        multiSelectFriendly = this.getOutOfStockLocations(initialOOSLocations, locationsTrueDropdownIndexes);
      }
      fieldData = multiSelectFriendly;
    }
    if (field.key === 'orderTypes') {
      if (Array.isArray(fieldData) && fieldData.includes('ALL')) {
        fieldData = orderTypes.map(type => type);
      } else {
        fieldData = isEmpty(fieldData) ? orderTypes : orderTypes.filter(type => this.state.orderTypes.includes(type.value));
      }
    }
    if (field.key === 'payAtDoorOptions') {
      fieldData = this.prepareValueForDropdown('payAtDoorOptions', this.state.payAtDoorOptions, payAtDoorOptions);
    }
    if (field.key === 'value' && resource === 'coupons' && subResource === 'restrictions') {
      if (this.state.type === 'DAYS_OF_WEEK') {
        fieldData = this.prepareValueForDropdown('value', this.state.value, daysOfWeek);
      }
      if (this.state.type === 'DELIVERY_TYPE') {
        fieldData = this.prepareValueForDropdown('value', this.state.value, deliveryType);
      }
    }
    if (field.key === 'currencyCode' && fieldData !== undefined) {
      fieldData = currencyCodes.filter(currencyCode => currencyCode.value === this.state.currencyCode)[0];
    }

    const isHiddenField = this.hideComponent(field);
    const isMultiLine = fieldType === 'longText';
    const textFieldRowHeight = fieldType === 'longText' ? '4' : '';
    const inputPropStyle = fieldType === 'longText' ? styles.descriptionInputPropStyle : styles.normalInputPropStyle;
    if (isHiddenField) return null;
    let fieldValues = {};
    if (resource === 'products' && type == 'create' && this.state.product) {
      fieldValues = {
        component: this.state.product.component,
        customizationView: this.state.product.customizationView,
        widthPercentage: this.state.product.widthPercentage,
        locations: this.state.product.locations,
        productTax: this.state.product.productTax,
      };
    } else if (resource === 'products' && type === 'edit') {
      fieldValues = {
        component: this.state.component,
        customizationView: this.state.customizationView,
        widthPercentage: this.state.widthPercentage,
        locations: this.state.locations,
        productTax: this.state.productTax,
      };
    }

    const disableField = this.shouldDisableField(field, isSubResource, requestsLeftToLoad);
    if (renderingCouponRestrictionValueField && ['FIRST_ORDER_OF_CUSTOMER', 'APPLY_TO_EACH_ITEM'].includes(this.state.type)) {
      return (
        <Typography style={styles.couponRestrictionUneditableTrueValueText}>
          YES
        </Typography>
      );
    }
    if (renderingCouponRestrictionValueField && searchableRestrictionTypes.includes(this.state.type)) {
      let options = [];
      if (['CATEGORY', 'EXCLUDE_CATEGORY'].includes(this.state.type) && Array.isArray(this.state.searchableCategories)) {
        options = this.state.searchableCategories;
      }
      if (['PRODUCT', 'EXCLUDE_PRODUCT'].includes(this.state.type) && Array.isArray(this.state.searchableProducts)) {
        options = this.state.searchableProducts;
      }
      if (['PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM'].includes(this.state.type) && Array.isArray(this.state.searchableProductItems)) {
        options = this.state.searchableProductItems;
      }
      if (['LOCATIONS'].includes(this.state.type) && Array.isArray(this.state.searchableLocations)) {
        options = this.state.searchableLocations;
      }
      if (['USERS'].includes(this.state.type)) {
        return (
          <div style={styles.searchableSelectContainer}>
            <SearchableSelect
              type={AsyncSelect}
              isMulti
              defaultOptions={searchableUsers}
              loadOptions={inputValue => this.debouncedLoadOptions(inputValue)}
              onChange={value => this.onChangeSearchableInput(value, 'value', true)}
              value={this.state.userIdsToNames}
            />
            { this.renderUserInstructions() }
          </div>
        )
      }
      if (options.length === 0) return;
      return (
        <div style={styles.searchableSelectContainer}>
          <SearchableSelect
            isMulti
            options={options}
            onChange={value => this.onChangeSearchableInput(value, 'value')}
            value={this.state.value}
          />
        </div>
      );
    }

    if (searchableItemsResources.includes(resource) && field.key === 'productItems') {
      const { searchableProductItems, productItems } = this.state;
      const options = Array.isArray(searchableProductItems) ? searchableProductItems : [];

      return (
        <SearchableSelect
          isMulti
          isClearable={false}
          options={options}
          onChange={value => this.onChangeSearchableInput(value, 'productItems')}
          value={Array.isArray(productItems) ? productItems : []}
        />
      );
    }

    if (fieldType === 'datetime') {
      return (
        <div style={{ flex: 1, paddingTop: '20px' }}>
          <DateTimePicker
            value={this.state.value}
            onChange={this.validateDateTimePickerValueAndUpdateValueState}
          />
          {isFieldInvalid
            && (
              <Typography style={styles.errorMessageStyle}>
                {this.getErrorMessage(fieldIndex, field)}
              </Typography>
            )
          }
        </div>
      );
    }

    if (fieldType === 'time') {
      return (
        <div style={{ flex: 1, paddingTop: '20px' }}>
          <TimePicker
            value={this.state.value}
            onChange={this.validateDateTimePickerValueAndUpdateValueState}
          />
          {isFieldInvalid
            && (
              <Typography style={styles.errorMessageStyle}>
                {this.getErrorMessage(fieldIndex, field)}
              </Typography>
            )
          }
        </div>
      );
    }

    if (this.predefinedFieldTypes && !this.predefinedFieldTypes.includes(fieldType)) {
      return (
        <React.Fragment>
          {((resource === 'categories' || resource === 'products') && field.key === 'description')
            && (
              <Typography style={styles.maxCharMessageStyle}>
                {`Max Characters: ${MAX_CHAR_DESCRIBE_TEXTFIELD}`}
              </Typography>
            )
          }
          <TextField
            key={field.key}
            id={field.key}
            value={(fieldData || fieldData === 0) ? fieldData : ''}
            margin="normal"
            multiline={isMultiLine}
            rows={textFieldRowHeight}
            onChange={(event) => { this.onChangeInput(event, field, isSubResource, id); }}
            style={isFieldInvalid ? styles.errorTextFieldStyle : styles.textFieldStyle}
            inputProps={{ ...inputPropStyle, maxLength: MAX_CHAR_DESCRIBE_TEXTFIELD }}
            InputProps={{ disableUnderline: true }}
            disabled={disableField}
          />
          {isFieldInvalid
            && (
              <Typography style={styles.errorMessageStyle}>
                {isSubResource === 'items' ? this.state[`item${id}InvalidFieldMessage`][field.key] : this.getErrorMessage(fieldIndex, field)}
              </Typography>
            )
          }
        </React.Fragment>
      );
    }

    const { admin } = this.props;
    const { hoursTabsWithErrors } = this.state;
    const isLocationAdmin = checkIsLocationAdmin(admin);
    return (
      <React.Fragment>
        <FieldType
          key={field.key}
          loading={fieldType === 'dropdown' ? false : loading}
          allowMultiple={correctAllowMultiple}
          allowNone={field.allowNone}
          isObject={field.isObject}
          data={fieldData}
          actions={actions}
          defaultValue={fieldData}
          dropdownOptions={dropdownOptions}
          dropdownType={field.dataTable}
          apiToken={apiToken}
          style={{ ...styles.fieldTypeStyle, border: isFieldInvalid ? '1px solid red' : '1px solid #979797' }}
          onChange={(event) => {
            this.onChangeInput(event, field, isSubResource, id);
          }}
          resourceName={resource}
          resources={resources}
          field={field}
          disabled={disableField}
          state={this.state}
          onAddHolidayHour={this.onAddHolidayHour}
          onChangeHolidayHour={this.onChangeHolidayHour}
          onDeleteHolidayHour={this.onDeleteHolidayHour}
          isLocationAdmin={isLocationAdmin}
          hoursTabsWithErrors={hoursTabsWithErrors}
        />
        {fieldType === 'image'
          && field.allowMultiple === false
          && resource === 'products'
          && !checkIsLocationAdmin(this.props.admin)
          && utilFunctions.isAdminEmailAccount(this.props.admin && this.props.admin.email)
          && (
            <div style={styles.advancedOptionsTextLinkContainer}>
              <Typography
                style={styles.advancedOptionsTextLink}
                color="primary"
                onClick={() => this.onOpenAndCloseAdvancedOptionsDialog()}
              >
                advanced options
              </Typography>
              {this.state.isAdvancedDialogOpen
                && (
                  <AdvancedProductDialog
                    isDialogOpen={this.state.isAdvancedDialogOpen}
                    onOpenAndCloseDialog={() => this.onOpenAndCloseAdvancedOptionsDialog()}
                    onClickSaveButton={updatedFieldData => this.onClickSaveButton(updatedFieldData)}
                    setDefaultState={() => this.setDefaultDialogState()}
                    resources={resources}
                    resourceId={resourceId}
                    fieldValues={fieldValues}
                    isDefault={this.state.isAdvancedDialogDefault}
                    actions={actions}
                    apiToken={apiToken}
                    loading={loading}
                  />
                )}

            </div>
          )
        }
        {isFieldInvalid
          && (
            <Typography style={field.key === 'hours' ? styles.hoursErrorMessage : styles.errorMessageStyle}>
              {isSubResource === 'items' ? this.state[`item${id}InvalidFieldMessage`][field.key] : this.getErrorMessage(fieldIndex, field)}
            </Typography>
          )
        }
        {resource === 'coupons' && subResource === 'restrictions' && field.key === 'type' && this.renderInstructions(field, fieldData)}
      </React.Fragment>
    );
  }

  onChangeHolidayHour = (ids, key, value) => {
    const { holidayHours } = this.state;
    const updatedHolidayHours = holidayHours.map((holiday) => {
      if (ids.includes(holiday.id)) {
        if (key === 'isClose' && value === false && holiday.open == null && holiday.close == null) {
          holiday.open = moment().format('HH:mm');
          holiday.close = moment().format('HH:mm');
        }
        holiday[key] = value;
      }
      return holiday;
    });
    this.setState({ holidayHours: updatedHolidayHours });
  }

  onAddHolidayHour = (date, businessOpenAllDay) => {
    const { holidayHours } = this.state;
    const newHolidayHour = {
      id: -Date.now(),
      date: date || Date.now() / 1000,
      businessOpenAllDay: businessOpenAllDay || false,
      open: moment().format('HH:mm'),
      close: moment().format('HH:mm'),
    };
    this.setState({ holidayHours: holidayHours ? [...holidayHours, newHolidayHour] : [newHolidayHour] });
  }

  onDeleteHolidayHour = (holidayHourToDeleteId) => {
    const { holidayHours } = this.state;
    const deletedHolidayHours = holidayHours.filter(holiday => holiday.id != holidayHourToDeleteId);
    this.setState({ holidayHours: deletedHolidayHours });
  }

  renderInstructions = (field, fieldData) => {
    const { resource, subResource } = this.props.match.params;
    if (fieldData && resource === 'coupons' && subResource === 'restrictions' && field.key === 'type') {
      const { value } = fieldData;
      return (
        <Typography style={styles.helpfulInstructions}>
          {value && instructions.restrictionTypes[value]}
        </Typography>
      );
    }
  };

  renderUserInstructions = () => {
    const { duplicatedUserIds, userIdsToNames } = this.state;
    const duplicatedNames = userIdsToNames && duplicatedUserIds && userIdsToNames.filter(user => duplicatedUserIds.indexOf(user.value.toString()) != -1 );
    const duplicatedNamesText = duplicatedNames && duplicatedNames.map(name => { return name.label }).join(', ');
    return (
      duplicatedNamesText
        ? (
          <Typography style={styles.userInstructionsError}>
            {`Error: you have existing user restriction for ${duplicatedNamesText}`}
          </Typography>
        )
        : (
          <Typography style={styles.userInstructions}>
            {`Enter user's name, email or phone number`}
          </Typography>
        )
    )
  }

  validateDateTimePickerValueAndUpdateValueState = (pickerValue) => {
    let isFieldInvalidCopy = this.state.isFieldInvalid.slice();
    let invalidFieldMessageCopy = this.state.invalidFieldMessage.slice();
    // moment.isValid()
    isFieldInvalidCopy[restrictionValueIndex] = !(pickerValue.isValid());
    if (!pickerValue.isValid()) {
      invalidFieldMessageCopy[restrictionValueIndex] = reselectDateTimeText;
    }

    this.setState({
      value: pickerValue,
      isFieldInvalid: isFieldInvalidCopy,
      invalidFieldMessage: invalidFieldMessageCopy,
    });
  }

  openEditDialog = async (fieldKey) => {
    const newDialogState = {
      openEditDialog: true,
      editDialogField: fieldKey,
      newContent: '',
    };
    await this.setState({
      dialogState: newDialogState,
    });
  };

  handleCloseDialog = (type) => {
    if (type === 'submit') {
      const { dialogState, name } = this.state;
      const head = `<head><title>${name}</title></head>`;
      const body = `<body bgcolor="#FFFFFF">${dialogState.newContent}</body>`;
      const newState = `<!DOCTYPE html><html>${head}${body}</html>`;
      this.setState({
        [dialogState.editDialogField]: newState,
      });
    }
    const newDialogState = {
      openEditDialog: false,
      editDialogField: null,
      newContent: '',
    };
    this.setState({
      dialogState: newDialogState,
    });
  };

  onEditorChange = (value) => {
    const { dialogState } = this.state;
    dialogState.newContent = value;
  }

  onChangeItemCustomizationInput = (event, field, subState, subField) => {
    const { type } = this.props;
    const inputVal = (event.target) ? event.target.value : event;
    let productItems;
    let index;
    if (this.state.product && this.state.product.productItems) {
      productItems = this.state.product.productItems;
      index = productItems.findIndex(item => item.selectedItem === true);
    }
    const pathname = this.props.location && this.props.location.pathname.toString();
    const customizationCpy = pathname === '/products/items/create' ? productItems[index][field.key].slice() : this.state[field.key].slice();
    customizationCpy.map((item, index) => {
      if (item.id === subState.id) {
        customizationCpy[index][subField.key] = inputVal;
      }
    });
    this.setState({ [field.key]: customizationCpy });
  }

  /**
   * this is very similar to onChangeItemCustomizationInput
   * Pulling and setting state differently
   */
  onChangeItemCustomizationInputProductPage = (event, fieldData, customization, custField, id) => {
    const inputVal = (event.target) ? event.target.value : event;
    const itemsCopy = cloneDeep(this.state.items);
    itemsCopy.map((item) => {
      if (item.id === id) {
        item.customizations.map((cust) => {
          if (cust.id === customization.id) {
            cust[custField.key] = inputVal;
          }
        });
      }
    });
    this.setState({ items: itemsCopy });
  }

  onClickDeleteItemCustomization = (field, customization) => {
    const pathname = this.props.location && this.props.location.pathname.toString();
    const { product } = this.state;
    const { productItems } = product;
    const stateDataCpy = this.state[field.key].filter(item => item.id !== customization.id);
    if (pathname === '/products/items/create' && productItems) {
      let { productItems } = this.state.product;
      productItems.forEach((item) => {
        if (item.selectedItem === true) {
          item.customizations = stateDataCpy;
          item.itemCusDialogContent = stateDataCpy;
        }
      });
      this.setState({
        product: {
          ...this.state.product,
          productItems,
        },
      });
    } else {
      this.setState({
        [field.key]: stateDataCpy,
        itemCusDialogContent: stateDataCpy,
      });
    }
  }

  onClickDeleteItemCustomizationProductPage = (field, customization, itemId) => {
    const itemCopy = this.state.items.slice();
    itemCopy.map((item) => {
      if (item.id === itemId) {
        item.customizations = item.customizations.filter(cust => cust.id !== customization.id);
        return;
      }
    });
    this.setState({ items: itemCopy });
  }

  onOpenAndCloseItemCusDialog = () => {
    const isOpen = this.state.isItemCusDialogOpen;
    this.setState({ isItemCusDialogOpen: !isOpen });
  }

  onOpenAndCloseAdvancedOptionsDialog = () => {
    const isOpen = this.state.isAdvancedDialogOpen;
    this.setState({ isAdvancedDialogOpen: !isOpen });
  }

  onClickSaveButton = (updatedFieldData) => {
    const { type } = this.props;
    let state = {};
    Object.keys(updatedFieldData).forEach((key) => {
      if (updatedFieldData[key] !== undefined && updatedFieldData[key] !== null) {
        if (updatedFieldData[key].value !== undefined) {
          state[key] = updatedFieldData[key].value;
        } else if (updatedFieldData[key].name !== undefined) {
          if (key === 'productTax') {
            state[key] = updatedFieldData[key];
          } else {
            state[key] = updatedFieldData[key].name;
          }
        } else if (Array.isArray(updatedFieldData[key])) {
          let multiSelect = [];
          updatedFieldData[key].forEach((object) => {
            multiSelect.push(object);
          });
          state[key] = multiSelect;
        } else if (typeof updatedFieldData[key] === 'string') {
          state[key] = updatedFieldData[key];
        }
      } else {
        state[key] = undefined;
      }
    });
    if (type === 'create') {
      this.setState({
        product: {
          ...this.state.product,
          component: state.component,
          customizationView: state.customizationView,
          widthPercentage: state.widthPercentage,
          locations: state.locations,
          productTax: state.productTax,
        },
        isAdvancedDialogDefault: false,
      });
    } else if (type === 'edit') {
      this.setState(state);
    }
    this.onOpenAndCloseAdvancedOptionsDialog();
  }

  setDefaultDialogState = () => {
    const defaultDialogState = {
      component: 'PRODUCT',
      customizationView: 'STEP_VIEW',
      widthPercentage: 50,
    };
    this.setState(defaultDialogState);
    return defaultDialogState;
  }

  // This sets the dialog content to the opened item's customizations when you open
  onOpenAndCloseItemCusDialogProductPage = async (itemId) => {
    if (!this.state.isItemCusDialogOpen) {
      let itemCpy;
      let customizationCpy;
      itemCpy = this.state.items.slice();
      itemCpy = itemCpy.filter(item => item.id === itemId)[0];
      customizationCpy = itemCpy.customizations;
      await this.setState({ isItemCusDialogOpen: true, itemCusDialogContent: customizationCpy, selectedItem: itemId });
    } else {
      await this.setState({ isItemCusDialogOpen: false });
    }
  }

  // This sets the dialog content to the selected item's
  onOpenAndCloseItemDeletionDialogProductPage = (item) => {
    if (!this.state.isDeleteConfirmDialogOpen) {
      this.setState({
        isDeleteConfirmDialogOpen: true,
        dataInDeleteConfirmDialog: item.name,
        selectedItem: item.id,
      });
    } else {
      this.setState({
        isDeleteConfirmDialogOpen: false,
      });
    }
  }

  toggleCancelOrderConfirmDialog = () => {
    this.setState({
      isDeleteConfirmDialogOpen: !this.state.isDeleteConfirmDialogOpen,
    });
  }

  onConfirmCancelOrderDialog = async () => {
    const { actions, apiToken } = this.props;
    const { prunedResource } = this.getStateValuesForSubmit();
    const resourcePath = this.getResourcePath();
    // update resource
    await actions.updateResource(apiToken, prunedResource, ...resourcePath);
    this.handleRefreshForEditPage();
  }

  getStateValuesForSubmit = () => {
    const { match } = this.props;
    const { resource, subResource } = match.params;
    const {
      dialogState,
      isFieldInvalid,
      disableSaveButton,
      errorText,
      daysOfWeekButtons,
      timeLimitSwitch,
      timeLimits,
      iconSwitch,
      stockSwitch,
      disabledSwitch,
      showNoteSwitch,
      isIconChecked,
      isItemCusDialogOpen,
      itemCusDialogContent,
      items,
      selectedItem,
      dataInDeleteConfirmDialog,
      isDeleteConfirmDialogOpen,
      invalidFieldMessage,
      ...resourceToUpdate
    } = this.state;
    // This prunes resourceToUpdate so that only valid fields are included in API call
    let fieldsToPick = [];
    resourceFields[subResource || resource].map((field) => {
      fieldsToPick.push(field.key);
    });
    const prunedResource = pick(resourceToUpdate, fieldsToPick);
    return {
      prunedResource,
      isFieldInvalid,
      timeLimitSwitch,
      timeLimits,
      iconSwitch,
      disabledSwitch,
      showNoteSwitch,
      isIconChecked,
      items,
      resourceToUpdate,
    };
  }

  getResourcePath = () => {
    const { match } = this.props;
    const {
      resource, subResource, subResourceId, resourceId,
    } = match.params;
    const resourcePath = this.generateEditPath(subResource, resource, resourceId, subResourceId);
    return resourcePath;
  }

  handleRefreshForEditPage = () => {
    const { match, history } = this.props;
    const { resource } = match.params;
    const primaryResource = ['categories', 'products', 'taxes'].includes(resource)
      ? 'menu'
      : resource;
    const nextRoute = this.getNextRoute(primaryResource);
    // Reload the page if nextRoute returns to an EDIT page
    const routePieces = nextRoute.split('/');
    const lastIndex = routePieces.length - 1;
    const isEditState = routePieces[lastIndex];
    isEditState && this.setState(this.createState());
    history.push(nextRoute);
  }

  onConfirmDeleteItem = () => {
    const { apiToken, actions, match } = this.props;
    const { resource, resourceId } = match.params;
    const selectedItemId = this.state.selectedItem;
    const subResource = resource === 'users' ? 'addresses' : 'items';
    actions.deleteResource(apiToken, resource, resourceId, subResource, selectedItemId);
    this.onOpenAndCloseItemDeletionDialogProductPage();
  }

  onClickAddNewVariation = (productItems) => {
    if (this.state.product.name !== undefined) {
      productItems[productItems.length - 1].name = this.state.product.name;
    }
    this.setState({
      product: {
        ...this.state.product,
        productItems,
      },
    });
  }

  onClickDuplicateVariation = (productItems) => {
    this.setState({
      product: {
        ...this.state.product,
        productItems,
      },
    });
  }

  onClickConfirmDeleteVariation = (name, id, productItems) => {
    let indexOfItemToBeDeleted = productItems.findIndex(item => item.id === id);
    if (indexOfItemToBeDeleted === 0 && productItems.length === 1) {
      this.setState({
        product: {
          ...this.state.product,
          productItems: [
            {
              name: `${name} Regular`,
              attribute_name: 'Size',
              attribute_value: 'Regular',
              price: 0,
              isDefault: true,
            },
          ],
        },
      });
    } else {
      if (productItems[indexOfItemToBeDeleted].isDefault === true) {
        productItems.splice(indexOfItemToBeDeleted, 1);
        productItems[0].isDefault = true;
      } else {
        productItems.splice(indexOfItemToBeDeleted, 1);
      }
      this.setState({
        product: {
          ...this.state.product,
          productItems,
        },
      });
    }
  }

  onAddNewCusToList = (event, dropdownOptions, allowMultiple) => {
    const selectedOption = utilFunctions.getSelectedOptions(event, dropdownOptions, allowMultiple);
    const pathname = this.props.location && this.props.location.pathname.toString();
    const { product } = this.state;
    const productItems = get(product, 'productItems');
    if (pathname === '/products/items/create' && productItems) {
      const { productItems } = this.state.product;
      productItems.forEach((item) => {
        if (item.selectedItem === true) {
          item.itemCusDialogContent = selectedOption;
        }
      });
      this.setState({
        product: {
          ...this.state.product,
          productItems,
        },
      });
    } else {
      this.setState({ itemCusDialogContent: selectedOption });
    }
  }

  onClickAddCusBtn = () => {
    const pathname = this.props.location && this.props.location.pathname.toString();
    const { product } = this.state;
    const { productItems } = product;
    const { type } = this.props;
    if (pathname === '/products/items/create' && productItems) {
      const { productItems } = this.state.product;
      productItems.forEach((item) => {
        if (item.selectedItem === true) {
          item.customizations = item.itemCusDialogContent;
        }
      });
      this.setState({
        product: {
          ...this.state.product,
          productItems,
        },
        isItemCusDialogOpen: !this.state.isItemCusDialogOpen,
      });
    } else {
      this.setState({
        customizations: this.state.itemCusDialogContent,
        isItemCusDialogOpen: !this.state.isItemCusDialogOpen,
      });
    }
  }

  onClickAddCusBtnProductPage = () => {
    const selectedItemId = this.state.selectedItem;
    const dialogContent = this.state.itemCusDialogContent;
    let customizationCpy;
    let itemsCopy = this.state.items.slice();
    itemsCopy.map((item) => {
      if (item.id === selectedItemId) {
        // copy the customization of the current item so that freeOptions gets carried over
        customizationCpy = item.customizations;
        item.customizations = dialogContent;
        // assign old freeOptions to new customization options
        customizationCpy.map((customization) => {
          item.customizations.map((itemCust) => {
            if (itemCust.id === customization.id) {
              itemCust.freeOptions = customization.freeOptions;
            }
          });
        });
      }
    });
    this.setState({
      // set the items to the item copy
      isItemCusDialogOpen: !this.state.isItemCusDialogOpen,
      items: itemsCopy,
    });
  }

  updateIsValidUIOnUpdateTimeLimit = (timeLimitCopy, index) => {
    const isWholeTimeLimitValid = TimeLimitUtils.isDayTimeLimitValid(timeLimitCopy);
    const areTimeLimitSubfieldsValidCopy = Immutable.asMutable(this.state.areTimeLimitSubfieldsValid, { deep: true });
    areTimeLimitSubfieldsValidCopy[index] = TimeLimitUtils.whatInDayTimeLimitIsValid(timeLimitCopy);
    this.setState({ areTimeLimitSubfieldsValid: areTimeLimitSubfieldsValidCopy });

    const { isFieldInvalid, invalidFieldMessage } = this.state;
    const {
      isFieldInvalidCopy, invalidFieldMessageCopy,
    } = FieldValidation.cloneResourceInvalidFieldUIState(isFieldInvalid, invalidFieldMessage);
    // Show error messages instead per time limit subfield within the TimeLimit component
    const errorMessage = '';
    const updateIsValidUIArgs = {
      isThisFieldInvalid: !isWholeTimeLimitValid, fieldIndex: timeLimitsIndex, isFieldInvalidCopy, invalidFieldMessageCopy, errorMessage,
    };
    this.updateValidationAndSaveButton(updateIsValidUIArgs);
  }

  onDaysButtonClick = (buttonIndex, index) => {
    const { daysOfWeekButtons, timeLimits } = this.state;
    const daysOfWeekButtonsCpy = Immutable.asMutable(daysOfWeekButtons, { deep: true });
    const btnStateCpy = daysOfWeekButtonsCpy[index];
    const timeLimitCpy = Immutable.asMutable(timeLimits, { deep: true });
    const currTimeLimit = timeLimitCpy[index];
    const weekdayName = days[buttonIndex].key;
    btnStateCpy[buttonIndex] = !btnStateCpy[buttonIndex];

    btnStateCpy[buttonIndex]
      ? currTimeLimit.daysOfWeek.push(weekdayName)
      : currTimeLimit.daysOfWeek.splice(currTimeLimit.daysOfWeek.indexOf(weekdayName), 1);

    daysOfWeekButtonsCpy[index] = btnStateCpy;
    this.updateIsValidUIOnUpdateTimeLimit(currTimeLimit, index);
    this.setState({
      daysOfWeekButtons: daysOfWeekButtonsCpy,
      timeLimits: timeLimitCpy,
    });
  }

  onTimePickerChange = (val, type, index) => {
    const { timeLimits } = this.state;
    const timeLimitsCopy = Immutable.asMutable(timeLimits, { deep: true });
    const timeLimitCopy = timeLimitsCopy[index];
    const newTime = `${val.hour()}:${val.minute()}`;
    const key = type === 'start' ? 'start' : 'end';
    timeLimitCopy[key] = newTime;
    this.updateIsValidUIOnUpdateTimeLimit(timeLimitCopy, index);
    this.setState({ timeLimits: timeLimitsCopy });
  }

  /**
   * if switch changes, it means switch shows up in webpage which indicates
   * the resources should have a timeLimits field, if the timeLimits is
   * undefined or the timeLimits array is empty, add a new timeLimit object
   */
  onTimeLimitSwitchChange = () => {
    const { timeLimits, timeLimitSwitch } = this.state;
    let timeLimitToValidate;
    if (!Array.isArray(timeLimits) || timeLimits.length === 0) {
      const newTimeLimit = {};
      newTimeLimit.start = moment(null, ['h:m a', 'H:m']);
      newTimeLimit.end = moment(null, ['h:m a', 'H:m']);
      newTimeLimit.daysOfWeek = [];
      this.setState({ timeLimits: [newTimeLimit] });
      timeLimitToValidate = newTimeLimit;
    }

    if (timeLimitSwitch) {
      this.updateIsValidUIOnTurnOffTimeLimitSwitch();
      this.setState({ timeLimitSwitch: !timeLimitSwitch });
      return;
    }

    timeLimitToValidate ? this.updateIsValidUIOnUpdateTimeLimit(timeLimitToValidate, 0) : timeLimits.forEach((timeLimit, index) => this.updateIsValidUIOnUpdateTimeLimit(timeLimit, index));
    this.setState({ timeLimitSwitch: !timeLimitSwitch });
  }

  updateIsValidUIOnTurnOffTimeLimitSwitch = () => {
    const { isFieldInvalid, invalidFieldMessage } = this.state;
    const {
      isFieldInvalidCopy, invalidFieldMessageCopy,
    } = FieldValidation.cloneResourceInvalidFieldUIState(isFieldInvalid, invalidFieldMessage);

    const updateUIArgs = {
      // Turning off the time limit switch means you're not using it
      isThisFieldInvalid: false,
      fieldIndex: timeLimitsIndex,
      isFieldInvalidCopy,
      invalidFieldMessageCopy,
    };

    this.updateValidationAndSaveButton(updateUIArgs);
  }

  toggleProductOutOfStockSwitch = () => {
    let outOfStock = [];
    const isSingleLocation = this.props.resources && this.props.resources.locations && Array.isArray(this.props.resources.locations) && this.props.resources.locations.length === 1;
    if (isSingleLocation && !this.state.outOfStock && !Array.isArray(this.state.outOfStock)) {
      outOfStock = OutOfStockAPIFormat.convertLocations(this.props.resources.locations);
    }
    if (isSingleLocation && Array.isArray(this.state.outOfStock)) {
      if (this.state.outOfStock.length === 0) {
        outOfStock = OutOfStockAPIFormat.convertLocations(this.props.resources.locations);
      }
      if (this.state.outOfStock.length === 1) {
        outOfStock = [];
      }
    }
    this.setState({
      outOfStock,
    });
  }

  onStockSwitchChange = (itemId) => {
    const { type } = this.props;
    if (type === 'create') {
      this.toggleProductOutOfStockSwitch();
    } else if (type === 'edit') {
      // !itemId when editing a product instead of an item
      if (!itemId) {
        this.toggleProductOutOfStockSwitch();
      }
      if (itemId) {
        if (!this.state.items || !Array.isArray(this.state.items)) return;
        const newItems = this.state.items.map((item) => {
          if (`${itemId}` !== `${item.id}`) return item;
          const outOfStockValue = item['out-of-stock'];
          if (typeof outOfStockValue === 'undefined' || outOfStockValue === null) {
            return item;
          }
          if (outOfStockValue === true) {
            item['out-of-stock'] = [];
            return item;
          }
          if (outOfStockValue === false) {
            if (this.props.resources.locations && Array.isArray(this.props.resources.locations)) {
              item['out-of-stock'] = OutOfStockAPIFormat.convertLocations(this.props.resources.locations);
            }
            return item;
          }
          if (this.props.resources.locations && Array.isArray(this.props.resources.locations)) {
            // Seems that if the out of stock boolean state depends on the location array, then with a length 0 array, true and false would be identical.
            if (this.props.resources.locations.length === 0) {
              return item;
            }
            if (this.props.resources.locations.length === 1 && outOfStockValue && Array.isArray(outOfStockValue)) {
              if (outOfStockValue.length === 0) {
                item['out-of-stock'] = OutOfStockAPIFormat.convertLocations(this.props.resources.locations);
                return item;
              }
              if (outOfStockValue.length === 1) {
                item['out-of-stock'] = [];
                return item;
              }
            }
          }
          return item;
        });
        this.setState({ items: newItems });
      }
    }
  }

  onDisabledSwitchChange = () => {
    const { match, type } = this.props;
    const { resource, subResource } = match.params;
    const pathname = this.props.location && this.props.location.pathname.toString();
    const { product } = this.state;
    const productItems = product && product.productItems;
    const index = productItems && productItems.findIndex(item => item.selectedItem === true);
    if (resource === 'products' && subResource !== 'items' && type === 'create') {
      this.setState({
        product: {
          ...product,
          isDisabled: !product.isDisabled,
          disabledSwitch: !product.disabledSwitch,
        },
      });
    } else if (pathname === '/products/items/create') {
      const isDisabled = productItems && productItems[index] && !productItems[index].isDisabled;
      const disabledSwitch = productItems && productItems[index] && !productItems[index].disabledSwitch;
      const item = { ...productItems[index], isDisabled, disabledSwitch };
      productItems.splice(index, 1, item);
      this.setState({
        product: {
          ...product,
          productItems,
        },
      });
    } else {
      this.setState({
        isDisabled: !this.state.isDisabled,
        disabledSwitch: !this.state.disabledSwitch,
      });
    }
  }

  onShowNoteSwitchChange = () => {
    const { type } = this.props;
    if (type === 'create') {
      this.setState({
        product: {
          ...this.state.product,
          showNote: !this.state.product.showNote,
          showNoteSwitch: !this.state.showNoteSwitch,
        },
      });
    } else if (type === 'edit') {
      this.setState({
        showNote: !this.state.showNote,
        showNoteSwitch: !this.state.showNoteSwitch,
      });
    }
  }

  onIconCheckBoxChange = (iconInfo, index) => {
    const { type } = this.props;
    const { isIconChecked } = type === 'create' ? this.state.product : this.state;
    const isIconCheckedCpy = isIconChecked.slice();
    isIconCheckedCpy[index] = !isIconCheckedCpy[index];

    const newIconState = [];
    productIcons.map((item, ind) => {
      if (isIconCheckedCpy[ind]) newIconState.push(item.key);
    });
    if (type === 'create') {
      this.setState({
        product: {
          ...this.state.product,
          icons: newIconState,
          isIconChecked: isIconCheckedCpy,
        },
      });
    } else if (type === 'edit') {
      this.setState({
        icons: newIconState,
        isIconChecked: isIconCheckedCpy,
      });
    }
  }

  renderGrid = (field) => {
    const { resource, subResource } = this.props.match.params;
    if (['payAtDoorOptions', 'payAtDoorAvailable', 'payNowAvailable'].includes(field.key) && resource === 'locations') {
      const admin = JSON.parse(sessionStorage.getItem('admin'));
      // If you don't know who is logged in, don't show these fields. We only want to show them to Craver staff,
      // as not every restaurant can offer payNow or payAtDoor
      if (!admin || !admin.email) return;
      const craverStaffAddress = /@admin\.com$/;
      if (!craverStaffAddress.test(admin.email)) return;
    }

    const { rewardType } = this.state;
    if (resource === 'tiers' && field.key === 'productItems' && rewardType === rewardTypes.DOLLAR) return null;

    return (
      !(field.key === 'customizations' && resource === 'customizations' && subResource === 'options')
      && !(field.type === 'image')
      && !(field.key === 'items')
      && !field.hideInEdit
      && !this.hideComponent(field)
      && (
        <Grid
          item
          key={field.key}
          xs={field.gridWidth ? parseInt(field.gridWidth) : 'auto'}
          style={styles.gridItem}
        >
          {this.renderGridFieldData(field)}
        </Grid>
      )
    );
  }

  renderGridFieldData = (field) => {
    const {
      actions, loading, resources, apiToken, match, type, width,
    } = this.props;
    const { resource, resourceId, subResource } = match.params;
    const itemTitle = utilFunctions.isDeviceView('sm', width) ? 'itemTitleSingleLine' : 'itemTitle';
    if (field.key === 'timeLimits') {
      const { areTimeLimitSubfieldsValid, timeLimitSwitch } = this.state;
      const isOnlyTimeLimit = this.state.timeLimits.length === 1;
      return (
        <div>
          <div style={styles.timeLimitSmallContainer}>
            <div style={styles.itemTitleContainer}>
              <Typography style={{ ...styles.itemTitle, paddingTop: '15px' }}>Time/Day Limit</Typography>
              <ToolTip resources={resources} field={field} />
            </div>
            <div style={styles.switchAndText}>
              <div>
                <IosSwitch
                  checked={timeLimitSwitch}
                  onChange={() => this.onTimeLimitSwitchChange()}
                  disableRipple
                />
              </div>
              <div style={styles.yesOrNoText}>
                {timeLimitSwitch ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
          {timeLimitSwitch && this.state.timeLimits.map((element, index) => (
            <TimeLimit
              key={field.key}
              timeLimitSwitch={this.state.timeLimitSwitch}
              daysButtonStates={this.state.daysOfWeekButtons[index]}
              onDaysButtonChange={buttonIndex => this.onDaysButtonClick(buttonIndex, index)}
              timeLimitData={this.state.timeLimits[index]}
              onTimePickerChange={(val, type) => this.onTimePickerChange(val, type, index)}
              resources={resources}
              field={field}
              areTimeLimitSubfieldsValid={areTimeLimitSubfieldsValid[index] || {}}
              onDelete={() => this.onDelete(index)}
              onAddAnother={this.onAddAnother}
              isOnlyTimeLimit={isOnlyTimeLimit}
            />
          ))}
        </div>
      );
    } else if (field.key === 'icons') { // Legend
      return (
        <ProductIcon
          fieldTitle={field.title}
          hideSwitch
          onCheckBoxChange={this.onIconCheckBoxChange}
          iconCheckBox={type === 'create' ? (this.state.product && this.state.product.isIconChecked) : this.state.isIconChecked}
          resources={resources}
          field={field}
        />
      );
    } else if (field.key === 'outOfStock' || field.key === 'out-of-stock') {
      if (this.props.resources && this.props.resources.locations && Array.isArray(this.props.resources.locations) && this.props.resources.locations.length <= 1) {
        let disabled = false;
        const productOrCustomizationOptionOutOfStock = this.state.outOfStock;
        const onStockSwitchChangeHOF = () => this.onStockSwitchChange();
        let iconSwitchState = false;
        if (this.props.resources.locations.length === 0) {
          iconSwitchState = true;
        }
        if (productOrCustomizationOptionOutOfStock && !Array.isArray(productOrCustomizationOptionOutOfStock)) {
          iconSwitchState = true;
        }
        if (this.props.resources.locations.length === 1 && productOrCustomizationOptionOutOfStock && Array.isArray(productOrCustomizationOptionOutOfStock)) {
          if (productOrCustomizationOptionOutOfStock.length === 1) {
            if (productOrCustomizationOptionOutOfStock[0].hasOwnProperty('value') && `${productOrCustomizationOptionOutOfStock[0].value}` === `${this.props.resources.locations[0].id}`) {
              iconSwitchState = true;
            }
            if (!productOrCustomizationOptionOutOfStock[0].hasOwnProperty('value') && `${productOrCustomizationOptionOutOfStock[0].id}` === `${this.props.resources.locations[0].id}`) {
              iconSwitchState = true;
            }
          }
        }
        return (
          <ProductIcon
            fieldTitle={outOfStockBooleanVersion.title}
            iconSwitch={iconSwitchState}
            onSwitchChange={onStockSwitchChangeHOF}
            onCheckBoxChange={this.onIconCheckBoxChange}
            resources={resources}
            field={outOfStockBooleanVersion}
            disabled={disabled}
          />
        );
      }
      return (
        <div>
          <div style={styles.itemTitleContainer}>
            <Typography style={styles[itemTitle]}>{`${field.title}:`}</Typography>
            <ToolTip resources={resources} field={field} width={width} />
          </div>
          {this.props.resources.locations && this.props.resources.locations.length > 1 && this.getFieldContent(field)}
        </div>
      );
    } else if (field.key === 'isDisabled') {
      const pathname = this.props.location && this.props.location.pathname.toString();
      const { product } = this.state;
      const productItems = product && product.productItems;
      const index = productItems && productItems.findIndex(item => item.selectedItem === true);
      let iconSwitch;
      if (pathname === '/products/create') {
        iconSwitch = product && product.isDisabled;
      } else if (pathname === '/products/items/create') {
        iconSwitch = productItems && productItems[index] && productItems[index].isDisabled;
      } else {
        iconSwitch = this.state.isDisabled;
      }
      return (
        <ProductIcon
          fieldTitle={field.title}
          iconSwitch={iconSwitch}
          onSwitchChange={this.onDisabledSwitchChange}
          onCheckBoxChange={this.onIconCheckBoxChange}
          iconCheckBox={this.state.product && this.state.product.isIconChecked}
          resources={resources}
          field={field}
          width={width}
        />
      );
    } else if (field.key === 'showNote') {
      return (
        <ProductIcon
          fieldTitle={field.title}
          iconSwitch={type === 'create' ? (this.state.product && this.state.product.showNote) : this.state.showNote}
          onSwitchChange={this.onShowNoteSwitchChange}
          resources={resources}
          field={field}
          width={width}
        />
      );
    } else if (field.key === 'customizations') {
      const pathname = this.props.location && this.props.location.pathname.toString();
      const { product } = this.state;
      const productItems = product && product.productItems;
      const index = productItems && productItems.findIndex(item => item.selectedItem === true);
      return (
        <ItemCustomization
          fieldData={field}
          itemCustomizationData={(pathname === '/products/items/create' && index !== -1) ? productItems[index][field.key] : this.state[field.key]}
          onOpenAndCloseDialog={this.onOpenAndCloseItemCusDialog}
          isDialogOpen={this.state.isItemCusDialogOpen}
          dropDownData={(pathname === '/products/items/create' && index !== -1) ? productItems[index].itemCusDialogContent : this.state.itemCusDialogContent}
          onChangeDialogDropDownOption={this.onAddNewCusToList}
          onClickAddButton={this.onClickAddCusBtn}
          getFieldType={this.getFieldTypeTag}
          actions={actions}
          loading={loading}
          resources={resources}
          apiToken={apiToken}
          onChangeFieldData={this.onChangeItemCustomizationInput}
          onDeleteItemCustomization={this.onClickDeleteItemCustomization}
          width={width}
          hidepadding
        />
      );
    } else if (field.isHtmlFormat) {
      return (
        <div>
          <Typography style={styles.itemTitle}>{`${field.title}:`}</Typography>
          <ModeEditIcon onClick={() => this.openEditDialog(field.key)} />
        </div>
      );
    } else {
      return (
        <div>
          <div style={styles.itemTitleContainer}>
            <Typography style={styles[itemTitle]}>{`${field.title}:`}</Typography>
            <ToolTip resources={resources} field={field} width={width} />
          </div>
          {this.getFieldContent(field)}
        </div>
      );
    }
  }

  onAddAnother = () => {
    this.setState(({
      timeLimits: [...this.state.timeLimits, { daysOfWeek: [], end: null, start: null }],
      daysOfWeekButtons: [...this.state.daysOfWeekButtons, new Array(7)],
      areTimeLimitSubfieldsValid: [...this.state.areTimeLimitSubfieldsValid, { hasDaysInWeek: false, isEndATimeString: false, isStartATimeString: false, isStartBeforeEnd: false }],
      disableSaveButton: true,
    }));
  }

  onDelete = (index) => {
    const timeLimitsCopy = Immutable.asMutable(this.state.timeLimits, { deep: true });
    const deleted = timeLimitsCopy.splice(index, 1);
    const timeLimitBtnCopy = Immutable.asMutable(this.state.daysOfWeekButtons, { deep: true });
    timeLimitBtnCopy.splice(index, 1);
    const areTimeLimitSubfieldsValidCopy = Immutable.asMutable(this.state.areTimeLimitSubfieldsValid, { deep: true });
    areTimeLimitSubfieldsValidCopy.splice(index, 1);
    this.setState(({
      timeLimits: timeLimitsCopy,
      daysOfWeekButtons: timeLimitBtnCopy,
      deletedTimeLimits: [...this.state.deletedTimeLimits, ...deleted],
      areTimeLimitSubfieldsValid: areTimeLimitSubfieldsValidCopy,
    }));
  }

  toggleCollapsibleItem = (targetIsOpen, itemId) => {
    this.setState({ [`item${itemId}IsExpanded`]: targetIsOpen });
  }

  renderItem = (item, isLocationAdmin) => {
    const {
      actions, loading, resources, apiToken,
    } = this.props;
    const itemResourceFieldPruned = isLocationAdmin ? resourceFields.collapsibleItemsForLocationAdmins : resourceFields.itemsCollapsed;
    const itemResourceFieldExpanded = isLocationAdmin ? resourceFields.collapsibleItemsForLocationAdmins : resourceFields.itemsExpanded;
    return (
      <CollapsibleItem
        isOpen={this.state[`item${item.id}IsExpanded`] || false}
        updateParentIsOpen={this.toggleCollapsibleItem}
        isLocationAdmin={isLocationAdmin}
        apiToken={apiToken}
        actions={actions}
        key={item.id}
        item={item}
        onClickDeleteIcon={Array.isArray(this.state.items) && this.state.items.length > 1 && this.onOpenAndCloseItemDeletionDialogProductPage}
        expandedView={(this.renderItemFields(item.id, itemResourceFieldExpanded, actions, loading, resources, apiToken))}
        collapsedView={(this.renderItemFields(item.id, itemResourceFieldPruned, actions, loading, resources, apiToken))}
      />
    );
  }

  generateEditPath = (subResource, resource, resourceId, subResourceId) => {
    if (resource === 'companies') {
      return [resource];
    }
    return (subResource) ? [resource, resourceId, subResource, subResourceId] : [resource, resourceId];
  }

  /**
    * Flush the state to prevent overlapping state properties
    * Redirect the page and provide a return url
    */
  redirectCreateProductItem = () => {
    const { match, history } = this.props;
    const { resource, resourceId } = match.params;
    sessionStorage.setItem('tempProductState', JSON.stringify(this.state));
    this.setState(this.createStateForCreating('items'));
    history.push(`/${resource}/${resourceId}/items/create`, { prevUrl: match.url });
  }

  /**
   * If a previous URL was specified when history was pushed, go to that
   * Otherwise return to default root page
   */
  getNextRoute = (primaryResource) => {
    const { history, match } = this.props;
    const {
      resource, subResource, resourceId,
    } = match.params;
    let historyState = history.location.state;
    if (history.location && history.location.pathname === '/products/create') {
      return '/menu';
    } else if (historyState) {
      return historyState.prevUrl;
    } else if (subResource) {
      return (`/${resource}/${resourceId}/${subResource}`);
    } else {
      return (`/${primaryResource}`);
    }
  }

  getErrorMessage = (fieldIndex, field, fieldValue) => {
    const { pathname } = this.props.location;
    const resourceToUpdate = fieldValue ? fieldValue : this.state[field.key];
    let errorMsg = '';
    if (field.type === 'dropdown') {
      errorMsg = 'Please select an option';
    } else if (field.isRequired && (resourceToUpdate === null || resourceToUpdate === undefined || resourceToUpdate === '')) {
      if (pathname === '/products/items/create' && ['name', 'attribute_name', 'attribute_value', 'price', 'isDefault'].includes(field.key)) {
        errorMsg = validationErrorMessages.items[field.key];
      } else {
        errorMsg = 'Please enter a value';
      }
    } else if (field.key === 'coordinates') {
      // The following message is more informative, so we want to use it. Sometimes, if
      // 'Please enter a value' is already in this.state.invalidFieldMessage,
      // 'Please enter a value' remains the errorMessage.
      return 'Please enter coordinate pairs (longitude, latitude) in a comma-delimited list. For example: -123.114675, 49.283773';
    } else if (field.key === 'squareId') {
      if (resourceToUpdate.length !== 13) {
        errorMsg = 'Square ID must be 13 characters in length.';
      }
      errorMsg += " Please enter only letters and numbers. SquareId cannot include special characters (for example, !@#$%)')`";
      return errorMsg;
    }
    return this.state.invalidFieldMessage[fieldIndex] || errorMsg;
  }

  /**
   * As this is called by getUnverifiedIndices, if the field you run this for does not pass validation,
   * then return the unverifiedIndices array parameter with the coordinate field's index pushed in.
   */
  validateCoordinates = (coordinateString, unverifiedIndices, field, index) => {
    if (coordinateString === '') {
      unverifiedIndices.push(index);
      return unverifiedIndices;
    }
    let coordinateArray = [];

    // This works on all values in the database.
    const nonCoordinateCharacter = /[^0-9\.,\-\s]/m;

    if (!coordinateString.includes(',')) {
      unverifiedIndices.push(index);
    } else {
      coordinateArray = coordinateString.split(',');
      for (let i in coordinateArray) {
        let prefix = coordinateArray[i].slice(0, 3);
        if (prefix === '0.0') {
          coordinateArray[i] = coordinateArray[i].substring(4);
        } else if (coordinateArray[i][0] === '0') {
          // Without this block, validation won't catch "0a" or any other strings that are 0 + one letter
          if (nonCoordinateCharacter.test(coordinateArray[i])) {
            unverifiedIndices.push(index);
            return unverifiedIndices;
          }
          coordinateArray[i] = coordinateArray[i].substring(2);
        }
      }

      // return early if coordinates do not pass above `nonCoordinateCharacter.test`
      if (unverifiedIndices.includes(index)) return unverifiedIndices;

      // Without this block, validation won't catch non-coordinate characters typed into
      // the last item of the list string until a comma is added.
      // The block below that removes the last element when the array length is odd also
      // stops the validation tests in the `coordinateArray.forEach` iterator from running
      // on the last element, since it no longer exists.
      if (nonCoordinateCharacter.test(last(coordinateArray))) {
        unverifiedIndices.push(index);
        return unverifiedIndices;
      }
      // if array length is odd, remove element at end of array
      if (coordinateArray.length % 2 !== 0) {
        let emptyString = coordinateArray.splice(-1, 1);
      }
      let isFiniteNumber = true;
      coordinateArray.forEach((coordinate) => {
        if (nonCoordinateCharacter.test(coordinate) || coordinate === '' || !isFinite(coordinate)) {
          isFiniteNumber = false;
        }
      });
      if (!isFiniteNumber) {
        unverifiedIndices.push(index);
        this.getErrorMessage(index, field);
      } else {
        let lats = [];
        let lngs = [];
        for (let i = 0; i < coordinateArray.length / 2; i++) {
          lats.push(Number(Number(coordinateArray[i * 2 + 1]).toFixed(3)));
          lngs.push(Number(Number(coordinateArray[i * 2]).toFixed(3)));
        }
        for (let lat in lats) {
          if (!(Math.abs(lat) <= 90)) {
            unverifiedIndices.push(index);
          }
        }
        for (let lng in lngs) {
          if (!(Math.abs(lng) <= 180)) {
            unverifiedIndices.push(index);
          }
        }
      }
    }
    return unverifiedIndices;
  }

  validateSquareIdReturnUnverifiedIndices = (resourceToUpdate, unverifiedIndices, index) => {
    const squareId = resourceToUpdate.squareId;
    if (squareId !== '' && squareId !== null && squareId.length !== 13) {
      unverifiedIndices.push(index);
    }
    if (squareId !== '' && squareId !== null && squareId.match(squareIdLettersAndNumbersOnly) === null) {
      unverifiedIndices.push(index);
    }
    return unverifiedIndices;
  }

  validateSquareId = (squareId) => {
    // Non-square companies load squareId: null into state. If a Square company starts out writing a square id
    // but deletes it before deciding to submit their location info, we also want to allow that
    if (squareId === '' || squareId === null) return true;
    if (squareId.length !== 13) return false;
    return squareIdLettersAndNumbersOnly.test(squareId);
  }

  /**
   * Returns a list of required fields that hvae not been filled
   * Returns empty array if all fields are filled
   * NOTE: At the moment only tiers have the isRequired flag set
   */
  getUnverifiedIndices(resource, resourceToUpdate) {
    const { type, location: { pathname } } = this.props;
    const { product } = this.state;
    const productItems = product && product.productItems;
    const productItem = productItems && productItems.find(item => item.selectedItem === true);
    let unverifiedIndices = [];
    const { subResource } = this.props.match.params;
    let displayFields = resourceFields[resource];
    displayFields.map((field, index) => {
      if (resource === 'coupons' && subResource === 'restrictions' && !this.state[field.key]) {
        unverifiedIndices.push(index);
      }
      if (field.isRequired) {
        if (resource === 'products' && type === 'create' && product && (product[field.key] === null || product[field.key] === undefined || product[field.key] === '')) {
          unverifiedIndices.push(index);
          this.getErrorMessage(index, field);
          // Create Item via Add Variation Advanced Options on Create Product page
        } else if (pathname === '/products/items/create' && productItem && (productItem[field.key] === null || productItem[field.key] === undefined || productItem[field.key] === '')) {
          unverifiedIndices.push(index);
          this.getErrorMessage(index, field);
          // Create Item via Add Item button on Edit Product page
        } else if (pathname !== '/products/items/create' && resource === 'items' && type === 'create' && (resourceToUpdate[field.key] === null || resourceToUpdate[field.key] === undefined || resourceToUpdate[field.key] === '')) {
          unverifiedIndices.push(index);
          this.getErrorMessage(index, field);
        } else if (((resource === 'products' && type === 'edit') || (resource !== 'products' && resource !== 'items')) && (resourceToUpdate[field.key] === null || resourceToUpdate[field.key] === '')) {
          unverifiedIndices.push(index);
          this.getErrorMessage(index, field);
        }
      } else if (field.key === 'coordinates') {
        unverifiedIndices = this.validateCoordinates(resourceToUpdate.coordinates, unverifiedIndices, field, index);
      } else if (field.key === 'squareId') {
        unverifiedIndices = this.validateSquareIdReturnUnverifiedIndices(resourceToUpdate, unverifiedIndices, index);
      } else if (field.key === 'currencyCode'
        && resourceToUpdate.squareId !== null
        && resourceToUpdate.squareId !== ''
        && (resourceToUpdate[field.key] === null || resourceToUpdate[field.key] === '')) {
        unverifiedIndices.push(index);
        this.getErrorMessage(index, field);
      }
    });
    const { isFieldInvalid } = this.state;
    let isFieldInvalidCopy = isFieldInvalid.slice();
    unverifiedIndices.forEach((i) => {
      isFieldInvalidCopy[i] = true;
      this.setState({
        isFieldInvalid: isFieldInvalidCopy,
      });
    });
    return unverifiedIndices;
  }

  getItemTitle = (device, fieldKey) => {
    if (!device) {
      return 'itemTitle';
    }
    switch (fieldKey) {
      case 'points':
        return 'itemTitleMobilePoints';
      default:
        return 'itemTitleMobile';
    }
  }

  renderItemFields(itemId, itemResourceField, actions, loading, resources, apiToken) {
    const { type, width } = this.props;
    return (
      <div style={styles.subgridItemContainer} key={itemId}>
        {itemResourceField.map((field) => {
          if (field.key === 'customizations') {
            let itemCustData = this.state.items.filter(item => item.id === itemId)[0].customizations;
            itemCustData && itemCustData.sort((a, b) => a.position - b.position);
            return (
              <div style={styles.itemCustomizationContainer} key={itemId}>
                <div style={styles.itemCustomizationTitleContainer}>
                  <Typography style={styles.customizationTitle}>MODIFIER GROUPS:</Typography>
                  <Typography
                    style={styles.addCusTextLink}
                    color="primary"
                    onClick={() => this.onOpenAndCloseItemCusDialogProductPage(itemId)}
                  >
                    add modifier group
                  </Typography>
                </div>
                <ItemCustomization
                  fieldData={field}
                  itemCustomizationData={itemCustData}
                  onOpenAndCloseDialog={this.onOpenAndCloseItemCusDialogProductPage}
                  isDialogOpen={false}
                  dropDownData={type === 'create' ? this.state.product.productItems[index].itemCusDialogContent : this.state.itemCusDialogContent}
                  onChangeDialogDropDownOption={this.onAddNewCusToList}
                  onClickAddButton={this.onClickAddCusBtnProductPage}
                  getFieldType={this.getFieldTypeTag}
                  actions={actions}
                  loading={loading}
                  resources={resources}
                  apiToken={apiToken}
                  itemId={itemId}
                  onChangeFieldData={this.onChangeItemCustomizationInputProductPage}
                  onDeleteItemCustomization={this.onClickDeleteItemCustomizationProductPage}
                  key={field.key}
                  dialogHidden
                  width={width}
                />
              </div>
            );
          } else {
            if (field.key === 'outOfStock' || field.key === 'out-of-stock' && this.props.resources && this.props.resources.locations && Array.isArray(this.props.resources.locations) && this.props.resources.locations.length <= 1) {
              let disabled = false;
              if (!this.state.items) {
                disabled = true;
              }
              const itemOutOfStockData = this.state.items.filter(item => item.id === itemId)[0]['out-of-stock'];
              if (!itemOutOfStockData) {
                disabled = true;
              }
              const onStockSwitchChangeHOF = () => this.onStockSwitchChange(itemId);
              let iconSwitchState = false;
              if (this.props.resources.locations.length === 0) {
                iconSwitchState = true;
              }
              if (this.props.resources.locations.length === 1 && itemOutOfStockData && Array.isArray(itemOutOfStockData)) {
                if (itemOutOfStockData.length === 1) {
                  if (itemOutOfStockData[0].hasOwnProperty('value') && `${itemOutOfStockData[0].value}` === `${this.props.resources.locations[0].id}`) {
                    iconSwitchState = true;
                  }
                  if (!itemOutOfStockData[0].hasOwnProperty('value') && `${itemOutOfStockData[0].id}` === `${this.props.resources.locations[0].id}`) {
                    iconSwitchState = true;
                  }
                }
              }
              return (
                <Grid
                  item
                  key={field.key}
                  xs={field.gridWidth ? parseInt(field.gridWidth) : 'auto'}
                  style={styles.subgridItem}
                >
                  <React.Fragment>
                    <div style={styles.itemTitleContainer} />
                    <ProductIcon
                      fieldTitle={outOfStockBooleanVersion.title}
                      iconSwitch={iconSwitchState}
                      onSwitchChange={onStockSwitchChangeHOF}
                      onCheckBoxChange={this.onIconCheckBoxChange}
                      resources={resources}
                      field={outOfStockBooleanVersion}
                      disabled={disabled}
                    />
                  </React.Fragment>
                </Grid>
              );
            }
            const isMobile = utilFunctions.isDeviceView('sm', width);
            const subgridItem = isMobile ? 'subgridItemMobile' : 'subgridItem';
            const itemTitle = this.getItemTitle(isMobile, 'points');
            return (
              <Grid
                item
                key={field.key}
                xs={field.gridWidth ? parseInt(field.gridWidth) : 'auto'}
                style={styles[subgridItem]}
              >
                <React.Fragment>
                  <div style={styles.itemTitleContainer}>
                    <Typography style={styles[itemTitle]}>{`${field.title}:`}</Typography>
                    <ToolTip resources={resources} field={field} items={itemResourceField} width={width} />
                  </div>
                  {this.getFieldContent(field, 'items', itemId)}
                </React.Fragment>
              </Grid>
            );
          }
        })}
      </div>
    );
  }

  isEmpty(object) {
    if (object === null) return true;
    if (object.length > 0) return false;
    if (object.length === 0) return true;
    if (typeof object !== 'object') return true;
    for (let key in ojbect) {
      if (hasOwnProperty.call(object, key)) return false;
    }
    return true;
  }

  formatAddressFieldTitle(key) {
    let title = key;
    if (key.includes('_')) {
      let titleArray = key.split('_');
      title = `${titleArray[0]} ${titleArray[1]}`;
    }
    return title;
  }

  renderAddress(address) {
    const { resources } = this.props;
    const deleteIcon = (
      <svg onClick={() => this.onOpenAndCloseItemDeletionDialogProductPage(address)} xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: 'auto' }} width="24" height="24" viewBox="0 0 24 24">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );

    const addresses = resourceFields.addresses;
    for (let field in addresses) {
      if (!(addresses[field].key in address)) {
        address[addresses[field].key] = '';
      }
    }

    return (
      <div style={nestedAddressStyles.addressContainer} key={address.id}>
        <div style={styles.subgridItemContainer}>
          {addresses.map(field => Object.entries(address).map(([key, value]) => (
            (field.key === key)
            && (
              <Grid item key={key} style={styles.subgridItem}>
                <React.Fragment>
                  <div style={styles.itemTitleContainer}>
                    <Typography style={styles.itemTitle}>
                      {this.formatAddressFieldTitle(key)}
                    </Typography>
                    <ToolTip resources={resources} field={field} />
                  </div>
                  <TextField
                    key={key}
                    value={value}
                    style={styles.textFieldStyle}
                    margin="normal"
                    inputProps={styles.normalInputPropStyle}
                    InputProps={{ disableUnderline: true }}
                  />
                </React.Fragment>
              </Grid>
            )
          )))}
          <Button
            onClick={() => this.redirectEditAddress(address.id, address)}
            variant="contained"
            color="primary"
            style={{ marginLeft: 'auto' }}
          >
            Edit Address
          </Button>
          {deleteIcon}
        </div>
      </div>
    );
  }

  redirectCreateAddress = () => {
    const { match, history } = this.props;
    const { resource, resourceId } = match.params;
    this.setState(this.createStateForCreating('users'));
    history.push(`/${resource}/${resourceId}/addresses/create`, { prevUrl: match.url });
  }

  redirectEditAddress = (addressId, address) => {
    const { match, history } = this.props;
    const { resource, resourceId } = match.params;
    history.push(`/${resource}/${resourceId}/addresses/${addressId}/edit`, { prevUrl: match.url, address });
  }

  hideFields = (resources, resource, fieldName) => {
    if (resource === 'locations' && resources && resources.companies !== undefined) {
      const posIntegration = resources.companies[0].posIntegration;

      resourceFields[fieldName].forEach((field) => {
        if (field.key === 'squareId' || field.key === 'currencyCode') {
          if (posIntegration !== 'SQUARE' && !field.hideInEdit) {
            field.hideInEdit = true;
          } else if (posIntegration === 'SQUARE' && field.hideInEdit) {
            field.hideInEdit = false;
          }
        }
      });
    }

    if (resource === 'tiers') {
      resourceFields[fieldName].forEach((field) => {
        if (field.key === 'dollarAmount') {
          if (this.state.rewardType !== 'DOLLAR') {
            field.hideInEdit = true;
            field.isRequired = false;
          } else {
            field.hideInEdit = false;
            field.isRequired = true;
          }
        }
      });
    }
  }

  showFieldsForAdminLevel = (fieldName, gridContainerWidth, isLocationAdmin) => {
    const { match } = this.props;
    const { resource, subResource } = match.params;
    let formFields = [];

    if (isLocationAdmin) {
      if (resource === 'products' && subResource !== 'items') {
        formFields = resourceFields.productsForLocationAdmin.map(field => this.renderGrid(field));
      } else if (subResource === 'items') {
        formFields = resourceFields.editItemsForLocationAdmins.map(field => this.renderGrid(field));
      } else if (resource === 'customizations' && subResource === 'options') {
        formFields = resourceFields.optionsForLocationAdmins.map(field => this.renderGrid(field));
      } else {
        formFields = resourceFields[fieldName].map(field => this.renderGrid(field));
      }
    } else {
      formFields = resourceFields[fieldName].map(field => this.renderGrid(field));
    }

    return (
      <Grid container spacing={24} style={{ ...styles.gridContainer, width: gridContainerWidth }}>
        {formFields}
      </Grid>
    );
  }

  render() {
    const {
      actions, match, resources, type, loading, apiToken, history, admin,
    } = this.props;
    const {
      resource, subResource, resourceId, subResourceId, address,
    } = match.params;

    const resourceForCheckIsAuthorized = resource === 'products' ? 'menu' : resource;
    const attemptedAction = type === 'create' ? 'add' : 'edit';
    const canAccountCreateOrEditResource = checkIsAuthorized(admin, resourceForCheckIsAuthorized, subResource, attemptedAction);

    if (!canAccountCreateOrEditResource) {
      return (
        <Redirect
          to={{
            pathname: '/unauthorized',
            state: { from: { resource, subResource } },
          }}
        />
      );
    }
    const { items } = this.state;
    items && items.sort((a, b) => a.position - b.position);
    const fieldName = (subResource === 'view' ? 'customizations' : subResource) || (resource);
    let imageField = [];
    const isLocationAdmin = checkIsLocationAdmin(admin);
    if (isLocationAdmin && resource === 'products' && subResource !== 'items') {
      imageField = resourceFields.productsForLocationAdmin.filter(field => field.type === 'image');
    } else {
      imageField = resourceFields[fieldName].filter(field => field.type === 'image');
    }
    const isolateField = imageField[0];
    const gridContainerWidth = isolateField ? '48%' : '100%';
    let resourceName = subResource ? subResource : resource;
    resourceName = utilFunctions.changeResourceDisplayName(resourceName, resourceDisplayNameMap);
    const resourceTitle = utilFunctions.capitalizeTheFirstLetterOfEachWord(utilFunctions.depluralizeResourceName(resourceName));
    const renderFieldsArgs = {
      resource,
      isLocationAdmin,
      isolateField,
      fieldName,
      gridContainerWidth,
    };
    let user = [];
    let addresses = [];
    // conditional prevents crashing on reload
    const isObjectEmpty = isEmpty(resources);
    if (!isObjectEmpty && resourceId && get(resources, 'resource')) {
      user = resources[resource].filter(user => user.id.toString() === resourceId.toString());
      user = user[0];
      if (user && user.addresses !== undefined) {
        addresses = user.addresses;
      }
    }
    this.hideFields(resources, resource, fieldName);
    return (
      resources[resource]
        ? (
          <div style={styles.container}>
            <div style={commonStyles.resourceHeader}>
              <div style={commonStyles.resourceName}>
                <Typography style={commonStyles.resourceName}>{type === 'edit' ? `Edit ${resourceTitle}` : `Create ${resourceTitle}`}</Typography>
              </div>
              <div style={commonStyles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} resourceId={resourceId} resourceName={this.state.name} subResource={subResource} subResourceId={subResourceId} />
              </div>
            </div>
            <Paper style={this.useNoHeightPaper(resource) ? commonStyles.paperNoHeight : commonStyles.paper}>
              <form noValidate autoComplete="off" style={styles.formContainer}>
                {this.renderFieldsByRouteAndWidth(renderFieldsArgs)}
                {resource === 'products' && type === 'create' && subResource !== 'items'
                  && (
                    <React.Fragment>
                      <Variation
                        onChangeInput={this.onChangeInput}
                        onClickConfirmDeleteVariation={(name, index, productItems) => this.onClickConfirmDeleteVariation(name, index, productItems)}
                        onClickAddNewVariation={productItems => this.onClickAddNewVariation(productItems)}
                        onClickDuplicateVariation={productItems => this.onClickDuplicateVariation(productItems)}
                        product={this.state.product}
                        categories={history.location.state && history.location.state.categories}
                        history={history}
                      />
                      {this.renderInvalidVariationDialog(this.state.product && this.state.product.productItems ? this.state.product.productItems : [])}
                    </React.Fragment>
                  )
                }
                {
                  // this only runs for products and productItems
                  // If subresourceId != null then we are in a subresource -> Don't render this
                  // IF no items (not products) -> this won't render
                  (!subResource && (resource === 'products' || resource === 'users') && resourceId)
                  && (
                    <div style={styles.subResourceContainer}>
                      <div style={styles.subResourceContainerHeader}>
                        {
                          (resource === 'products')
                            ? (!isLocationAdmin && (
                              <React.Fragment>
                                <Typography style={styles.title}>Variations</Typography>
                                <Button
                                  onClick={() => this.redirectCreateProductItem()}
                                  variant="contained"
                                  color="primary"
                                >
                                  Add Variations
                                </Button>
                              </React.Fragment>
                            ))
                            : (
                              <React.Fragment>
                                <Typography style={styles.title}>Addresses</Typography>
                                <Button
                                  onClick={() => this.redirectCreateAddress()}
                                  variant="contained"
                                  color="primary"
                                >
                                  Add Address
                                </Button>
                              </React.Fragment>
                            )
                        }
                      </div>
                      {
                        (resource === 'products')
                        && (
                          <React.Fragment>
                            {/* For Edit Product page with CollapsibleItems */}
                            {this.renderInvalidVariationDialog(this.state.items)}
                            <Grid container spacing={utilFunctions.isDeviceView('md', this.props.width) ? 0 : 24} style={styles.subgridContainer}>
                              {items && items.map(item => this.renderItem(item, isLocationAdmin))}
                            </Grid>
                          </React.Fragment>
                        )
                      }
                      {
                        (resource === 'users')
                        && (
                          <Grid container spacing={24} style={styles.subgridContainer}>
                            {addresses.map(address => this.renderAddress(address))}
                          </Grid>
                        )
                      }
                      <Dialog
                        maxWidth="md"
                        open={this.state.isItemCusDialogOpen}
                        onClose={() => this.onOpenAndCloseItemCusDialogProductPage(this.state.selectedItem)}
                      >
                        <DialogContent style={styles.addItemCusDialogContainer}>
                          <IconButton
                            style={styles.itemCusDialogCloseBtn}
                            onClick={() => this.onOpenAndCloseItemCusDialogProductPage()}
                          >
                            <Icon>close</Icon>
                          </IconButton>
                          <img src={customizationLogo} style={{ marginTop: '50px' }} />
                          <Typography style={styles.itemCusDialogTitle}>ADD MODIFIER GROUP</Typography>
                          <Dropdown
                            data={type === 'create' ? this.state.product.productItems[index].itemCusDialogContent : this.state.itemCusDialogContent}
                            actions={actions}
                            dropdownOptions={resources.customizations}
                            dropdownType='customizations'
                            loading={loading}
                            allowMultiple
                            apiToken={apiToken}
                            style={styles.customizationDropdownStyle}
                            onChange={event => this.onAddNewCusToList(event, resources.customizations, true)}
                          />
                          <Button
                            style={styles.itemCusBtnInDialog}
                            onClick={() => this.onClickAddCusBtnProductPage()}
                          >
                            ADD
                          </Button>
                          <Typography
                            style={styles.itemCusDialogCancelText}
                            onClick={() => this.onOpenAndCloseItemCusDialogProductPage()}
                          >
                            cancel
                          </Typography>
                        </DialogContent>
                      </Dialog>
                      <DeleteConfirmDialog
                        resourceName={resource}
                        isDialogOpen={this.state.isDeleteConfirmDialogOpen}
                        deleteDataName={this.state.dataInDeleteConfirmDialog}
                        onCloseDialog={this.onOpenAndCloseItemDeletionDialogProductPage}
                        onClickConfirmButton={this.onConfirmDeleteItem}
                      />
                    </div>
                  )
                }

              </form>
              {this.renderInvalidVariationDialogForOldCreateEditItems()}
              <EditorDialog
                isDialogOpen={this.state.dialogState.openEditDialog}
                onCloseDialog={this.handleCloseDialog}
                onEditorChangeInput={this.onEditorChange}
                editorInitialValue={this.state[this.state.dialogState.editDialogField]}
              />

              {
                resource !== 'products'
                && (
                  <div style={styles.buttonWrapper}>
                    {
                      this.shouldDisableSaveButton()
                      && (
                        <div style={{ paddingLeft: '30px', fontFamily: 'Lato', color: 'red' }}>
                          {this.state.errorText}
                        </div>
                      )
                    }
                    <Button
                      variant="contained"
                      disabled={this.shouldDisableSaveButton()}
                      onClick={() => this.onClickApplyChanges()}
                      style={{
                        ...styles.applyChangeButton,
                        backgroundColor: this.shouldDisableSaveButton() ? 'lightGrey' : '#fff',
                      }}
                    >
                      Apply Changes
                    </Button>
                  </div>
                )
              }
            </Paper>
            <div style={styles.bottomBelowPaperContainer}>
              <VersionAndBuildNumber containerStyle={styles.bottomLeftBelowPaperSubContainer} />
              <div style={styles.applyChangesButtonSolidContainer}>
                <Button
                  variant='contained'
                  disabled={this.shouldDisableSaveButton()}
                  onClick={() => this.onClickApplyChanges()}
                  style={{
                    ...styles.applyChangesButtonSolid,
                    backgroundColor: this.shouldDisableSaveButton() ? 'lightGrey' : '#e0592a',
                  }}
                >
                  {this.props.loading ? <CircularProgress style={styles.applyChangesButtonSpinner} /> : 'APPLY CHANGES'}
                </Button>
                {
                  this.state.isDeleteConfirmDialogOpen
                  && (
                    <DeleteConfirmDialog
                      resourceName={resource}
                      deleteDataName={this.state.dataInDeleteConfirmDialog}
                      isDialogOpen={this.state.isDeleteConfirmDialogOpen}
                      onClickConfirmButton={(resource === 'products') ? this.onConfirmDeleteItem : this.onConfirmCancelOrderDialog}
                      onCloseDialog={this.toggleCancelOrderConfirmDialog}
                    />
                  )
                }
              </div>
            </div>
          </div>
        )
        : <LoadingBar />
    );
  }

  useNoHeightPaper = resource => resource === 'tiers';

  renderFieldsByRouteAndWidth = ({
    resource,
    isLocationAdmin,
    isolateField,
    fieldName,
    gridContainerWidth,
  }) => {
    return resource === 'products' && utilFunctions.isDeviceView('md', this.props.width)
      ? this.renderEditProductFields(isLocationAdmin, isolateField)
      : this.renderFields(fieldName, gridContainerWidth, isLocationAdmin, isolateField);
  }

  renderFields(fieldName, gridContainerWidth, isLocationAdmin, isolateField) {
    return (
      <Grid container xs={12} style={styles.gridContainer}>
        {this.showFieldsForAdminLevel(fieldName, gridContainerWidth, isLocationAdmin)}
        {isolateField
          && (
            <div style={styles.isolatedField}>
              {this.getFieldContent(isolateField)}
            </div>
          )}
      </Grid>
    );
  }

  renderEditProductFields(isLocationAdmin, isolateField) {
    return (
      <Grid container xs={12} style={styles.gridContainer}>
        {this.showFieldsForAdminLevel('productsMobileTop', '50%', isLocationAdmin)}
        {isolateField
          && (
            <Grid container xs={6} style={styles.gridContainer}>
              {this.getFieldContent(isolateField)}
              {this.showFieldsForAdminLevel('productsMobileBottom', '100%', isLocationAdmin)}
            </Grid>
          )}
      </Grid>
    );
  }
}

CreateAndEditResource.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  resources: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const pipeline = flowRight([withRouter, withWidth()]);
export default pipeline(CreateAndEditResource);
